import EmbeddingType from './utils/embeddingType';

/* Preview Panel Constants */
export const previewPanel = {
  IFRAME_TITLE: 'Preview iframe',
  IFRAME_ID: 'preview-iframe',
  EMBEDDING_DOSSIER_CONTAINER_ID: 'embedding-dossier-container', // Used for microstrategy.dossier.create
  EMBEDDING_CONTAINER_ID: 'embedding-container', // Used for microstrategy.embeddingContexts
  INJECTED_SCRIPT_ID: 'embedding-dossier-code',
};

/* Operations Constant */
const documentation = {
  PROPERTIES: {
    GENERAL:
      'https://microstrategy.github.io/embedding-sdk-docs/add-functionality/methods-and-properties',
  },
  AUTHENTICATION: {
    GUEST:
      'https://microstrategy.github.io/embedding-sdk-docs/support-for-different-authentication-environments/guest-authentication-mode-only',
    STANDARD:
      'https://microstrategy.github.io/embedding-sdk-docs/support-for-different-authentication-environments/',
    SAML: 'https://microstrategy.github.io/embedding-sdk-docs/support-for-different-authentication-environments/authentication-saml',
    IDENTITY:
      'https://microstrategy.github.io/embedding-sdk-docs/support-for-different-authentication-environments/seamless-login',
    /* OAuth2:
      'https://microstrategy.github.io/embedding-sdk-docs/support-for-different-authentication-environments/oauth2-apis', */
  },
  GENERAL: {
    INTRO: 'https://microstrategy.github.io/embedding-sdk-docs/',
  },
  ERROR: {
    DURING_DOSSIER_CREATION:
      'https://microstrategy.github.io/embedding-sdk-docs/add-functionality/error-handling#custom-error-handling-during-dossier-creation',
    AFTER_DOSSIER_CREATION:
      'https://microstrategy.github.io/embedding-sdk-docs/add-functionality/error-handling#custom-error-handling-after-dossier-creation',
    SESSION_ERROR_DURING_DOSSIER_CREATION:
      'https://microstrategy.github.io/embedding-sdk-docs/add-functionality/error-handling#session-error-handling-during-dossier-creation',
    SESSION_ERROR_AFTER_DOSSIER_CREATION:
      'https://microstrategy.github.io/embedding-sdk-docs/add-functionality/error-handling/#session-error-handling-after-dossier-creation',
  },
  NAVIGATION: {
    GENERAL: 'https://microstrategy.github.io/embedding-sdk-docs/add-functionality/add-nav',
    GET_TABLE_CONTENT:
      'https://microstrategy.github.io/embedding-sdk-docs/add-functionality/add-nav/#gettablecontent',
    GO_TO_NEXT_PAGE:
      'https://microstrategy.github.io/embedding-sdk-docs/add-functionality/add-nav/#gotoprevpage',
    GO_TO_PREV_PAGE:
      'https://microstrategy.github.io/embedding-sdk-docs/add-functionality/add-nav/#gotonextpage',
    NAVIGATE_TO_PAGE:
      'https://microstrategy.github.io/embedding-sdk-docs/add-functionality/add-nav/#navigatetopagepagepage',
    GET_CURRENT_CHAPTER:
      'https://microstrategy.github.io/embedding-sdk-docs/add-functionality/add-nav/#getcurrentchapter',
    GET_CURRENT_PAGE:
      'https://microstrategy.github.io/embedding-sdk-docs/add-functionality/add-nav/#getcurrentpage',
    GET_PAGE_BY_NODE_KEY:
      'https://microstrategy.github.io/embedding-sdk-docs/add-functionality/add-nav/#getpagebynodekeynodekey',
    GET_CHAPTER_LIST:
      'https://microstrategy.github.io/embedding-sdk-docs/add-functionality/add-nav/#getchapterlist',
    GET_CURRENT_PAGE_VISUALIZATION_LIST:
      'https://microstrategy.github.io/embedding-sdk-docs/add-functionality/add-nav/#getcurrentpagevisualizationlist',
    OPEN_FILTER_SUMMARY_BAR:
      'https://microstrategy.github.io/embedding-sdk-docs/add-functionality/add-nav/#openfiltersummarybar',
    CLOSE_FILTER_SUMMARY_BAR:
      'https://microstrategy.github.io/embedding-sdk-docs/add-functionality/add-nav/#closefiltersummarybar',
    GET_PAGE_LIST:
      'https://microstrategy.github.io/embedding-sdk-docs/add-functionality/add-nav/#getpagelist',
    LIBRARY_PAGES:
      'https://microstrategy.github.io/embedding-sdk-docs/embedding-context/#gotopagepageinfo',
  },
  EVENTS: {
    GENERAL: 'https://microstrategy.github.io/embedding-sdk-docs/add-functionality/add-event',
  },
  FILTERS: {
    GENERAL: 'https://microstrategy.github.io/embedding-sdk-docs/add-functionality/filters',
    RETRIEVE_FILTERS:
      'https://microstrategy.github.io/embedding-sdk-docs/add-functionality/filters#retrieve-filters-after-a-dossier-is-rendered',
    APPLY_FILTERS:
      'https://microstrategy.github.io/embedding-sdk-docs/add-functionality/filters#apply-a-filter-after-the-dossier-is-rendered',
    APPLY_MULTIPLE_FILTERS:
      'https://microstrategy.github.io/embedding-sdk-docs/add-functionality/filters#apply-multiple-filters-after-the-dossier-is-rendered',
  },
  PANEL_STACKS: {
    GENERAL: 'https://microstrategy.github.io/embedding-sdk-docs/add-functionality/panel-stacks',
  },
  VISUALIZATION: {
    GENERAL: 'https://microstrategy.github.io/embedding-sdk-docs/add-functionality/embed-vis',
    SELECT_ATTRIBUTE_ELEMENTS:
      'https://microstrategy.github.io/embedding-sdk-docs/add-functionality/attribute-element-selection',
  },
  AUTHORING: {
    GENERAL:
      'https://microstrategy.github.io/embedding-sdk-docs/add-functionality/authoring-library',
  },
  LIBRARY_PAGE: {
    GENERAL: 'https://microstrategy.github.io/embedding-sdk-docs/embed-library-main-page/',
    PROPERTIES:
      'https://microstrategy.github.io/embedding-sdk-docs/embed-library-main-page/embed-library-properties',
    APIS: 'https://microstrategy.github.io/embedding-sdk-docs/embed-library-main-page/library-page-apis',
    CUSTOM_UI:
      'https://microstrategy.github.io/embedding-sdk-docs/embed-library-main-page/embed-custom-ui-on-all-pages',
  },
  BOT_PAGE: {
    PROPERTIES:
      'https://microstrategy.github.io/embedding-sdk-docs/embed-bot-consumption-page/embed-bot-consumption-properties',
  },
  NATIVE_VISUALIZATION: {
    GET_INFO:
      'https://microstrategy.github.io/embedding-sdk-docs/native-embedding-architecture/dossier-info-api',
    APPLY_FILTER:
      'https://microstrategy.github.io/embedding-sdk-docs/native-embedding-architecture/apply-filter',
    EVENT_HANDLING:
      'https://microstrategy.github.io/embedding-sdk-docs/native-embedding-architecture/event-handling',
  },
};
export const codeLocation = {
  PROPERTY: '// INSERT PROPERTIES ABOVE HERE',
  METHOD: '// INSERT METHODS ABOVE HERE',
};

const navigateGroup = {
  groupName: 'Navigate',
  operationList: [
    {
      displayName: 'Navigate to a page on the MicroStrategy Library',
      tooltip:
        'Navigate to a MicroStrategy Library page, which can be the homepage, a dossier, bot or report page.',
      link: documentation.NAVIGATION.LIBRARY_PAGES,
      location: codeLocation.METHOD,
      code: `/* Navigate to a page on the MicroStrategy Library Start*/
      embeddingContext.goToPage({
        // application id can be omitted if the current application is the default application
        applicationId: 'C2B2023642F6753A2EF159A75E0CFF29',
        // If you want to navigate to the homepage, the fields below are not needed
        projectId: 'A728B9A98C420236E6C825AAB4A812D6',
        objectId: '8CF183CB4346C729EC6E2EA368BF49ED',
        pageKey: 'W66AE9E04126845EB96453C9C9EB39628',
        isAuthoring: false,
      });
      /* Add Custom Error Handler During Bot Creation End*/`,
    },
  ],
};

const nativeAuthentication = [
  {
    displayName: 'SAML Authentication',
    tooltip: 'Authenticate using SAML',
    link: documentation.AUTHENTICATION.SAML,
    location: codeLocation.PROPERTY,
    code: `/* SAML Authentication Start */
     config.getAuthToken = async () => {
      try {
        return await microstrategy.auth.samlLogin(
          serverUrl
        );
      } catch (e) {
        console.error(e.message);
        if (
          e.message ===
          "Failed to open a new tab for login or the new tab handler cannot be got. Please contact your administrator."
        ) {
          alert(
            "Please enable popups to be directed to the login site. Refresh the page once popups have been enabled."
          );
        }
      }
    }
    /* SAML Authentication End */`,
  },
  {
    displayName: 'OIDC Authentication',
    tooltip: 'Authenticate using OIDC',
    link: documentation.AUTHENTICATION.SAML,
    location: codeLocation.PROPERTY,
    code: `/* OIDC Authentication Start */
     config.getAuthToken = async () => {
      try {
        return await microstrategy.auth.oidcLogin(
          serverUrl
        );
      } catch (e) {
        console.error(e.message);
        if (
          e.message ===
          "Failed to open a new tab for login or the new tab handler cannot be got. Please contact your administrator."
        ) {
          alert(
            "Please enable popups to be directed to the login site. Refresh the page once popups have been enabled."
          );
        }
      }
    }
    /* OIDC Authentication End */`,
  },
  {
    displayName: 'Guest Authentication',
    tooltip: 'Authenticate as a guest user',
    link: documentation.AUTHENTICATION.GUEST,
    location: codeLocation.PROPERTY,
    code: `/* Guest Authentication Start */
    config.getAuthToken = async () => {
      options = {
        method: "POST",
        credentials: "include", // Including cookie
        mode: "cors", // Setting as cors mode for cross origin
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          loginMode: 8, // 8 means guest login
        }),
      };
      return fetch(
        serverUrl + "/api/auth/login",
        options
      ).then((response) => {
        if (response.ok) {
          console.log(
            "A new guest login session has been created successfully, logging in"
          );
          return response.headers.get("x-mstr-authtoken");
        } else response.json().then((json) => console.log(json));
      })
      .catch((error) =>
        console.error("Failed Guest Login with error:", error)
      );
    };
    /* Guest Authentication End */`,
  },
  {
    displayName: 'Standard Authentication',
    tooltip: 'Authenticate using standard mode',
    link: documentation.AUTHENTICATION.STANDARD,
    location: codeLocation.PROPERTY,
    code: `/* Standard Authentication Start */
    config.getAuthToken = async () => {
      async function createAuthToken() {
        // Make a call to REST API to log the user in
        const options = {
          method: "POST",
          credentials: "include", // Including cookie
          mode: "cors", // Setting as cors mode for cross origin
          headers: { "content-type": "application/json" },
          body: JSON.stringify({
            loginMode: 1, // 1 means Standard login
            username: "userNamePlaceHolder", // use guest / no password to test
            password: "passwordPlaceHolder",
          }),
        };

        try {
          const response = await fetch(
            serverUrl + "/api/auth/login",
            options
          );

          if (response.ok) {
            console.log(
              "A new standard login session has been created successfully, logging in"
            );
            return response.headers.get("x-mstr-authtoken");
          } else {
            const json = await response.json();
            console.log(json);
          }
        } catch (error) {
          console.error("Failed Standard Login with error:", error);
        }
      }
      return await createAuthToken();
    };
    /* Standard Authentication End */`,
  },
  {
    displayName: 'LDAP Authentication',
    tooltip: 'Authenticate using LDAP mode',
    link: documentation.AUTHENTICATION.STANDARD,
    location: codeLocation.PROPERTY,
    code: `/* LDAP Authentication Start */
    config.getAuthToken = async () => {
      async function createAuthToken() {
        // Make a call to REST API to log the user in
        const options = {
          method: "POST",
          credentials: "include", // Including cookie
          mode: "cors", // Setting as cors mode for cross origin
          headers: { "content-type": "application/json" },
          body: JSON.stringify({
            loginMode: 16, // 16 means LDAP login
            username: "userNamePlaceHolder", // use guest / no password to test
            password: "passwordPlaceHolder",
          }),
        };

        try {
          const response = await fetch(
            serverUrl + "/api/auth/login",
            options
          );

          if (response.ok) {
            console.log(
              "A new LDAP login session has been created successfully, logging in"
            );
            return response.headers.get("x-mstr-authtoken");
          } else {
            const json = await response.json();
            console.log(json);
          }
        } catch (error) {
          console.error("Failed LDAP Login with error:", error);
        }
      }
      return await createAuthToken();
    };
    /* LDAP Authentication End */`,
  },
  {
    displayName: 'Identity Token Authentication',
    tooltip: 'Authenticate using identity token',
    link: documentation.AUTHENTICATION.IDENTITY,
    location: codeLocation.PROPERTY,
    code: `/* Identity Authentication Start */
    config.getAuthToken = async function login() {
    async function createAuthToken() {
      // Make a call to REST API to log the user in
      const options = {
        method: "POST",
        credentials: "include", // Including cookie
        mode: "cors", // Setting as cors mode for cross origin
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          loginMode: 1, // 1 means Standard login
          username: "userNamePlaceHolder", // use guest / no password to test
          password: "passwordPlaceHolder",
        }),
      };

      try {
        const response = await fetch(
          serverUrl + "/api/auth/login",
          options
        );

        if (response.ok) {
          console.log(
            "A new standard login session has been created successfully, logging in"
          );
          return response.headers.get("x-mstr-authtoken");
        } else {
          const json = await response.json();
          console.log(json);
        }
      } catch (error) {
        console.error("Failed Standard Login with error:", error);
      }
    }

    async function getIdentityToken(authToken) {
      const identityOptions = {
        method: "GET",
        credentials: "include", // Including cookie
        mode: "cors", // Setting as cors mode for cross origin
        headers: {
          "Content-Type": "application/json",
          "X-MSTR-AuthToken": authToken,
        },
      };

      try {
        const response = await fetch(
          serverUrl + "/api/auth/identityToken",
          identityOptions
        );

        if (response.ok) {
          return response.headers.get("x-mstr-identitytoken");
        } else {
          const json = await response.json();
          console.log(json);
        }
      } catch (error) {
        console.error("Failed Identity Login with error:", error);
      }
    }

    return await getIdentityToken(await createAuthToken());
  };
  /* Identity Authentication End */`,
  },
  // {
  //   displayName: 'OAuth2 Authentication',
  //   tooltip: 'Authenticate using OAuth2',
  //   link: documentation.AUTHENTICATION.OAuth2,
  //   location: codeLocation.PROPERTY,
  //   code: `/* OAuth2 Authentication Start */
  //   config.getAuthToken = async () => {
  //     const {accessToken} = await microstrategy.auth.oauthLogin(serverUrl, {
  //             clientId: "your client id",
  //             clientSecret: "your client secret",
  //             requireRefreshToken: true,
  //           });
  //     return accessToken
  //   };
  //   /* OAuth2 Authentication End */`,
  // },
];

// Based on https://demo.microstrategy.com/MicroStrategyLibrary/app/B7CA92F04B9FAE8D941C3E9B7E0CD754/27D332AC6D43352E0928B9A1FCAF4AB0
export const operations = [
  {
    embeddingType: EmbeddingType.Dashboard,
    operationGroups: [
      {
        groupName: 'Authentication',
        operationList: [
          {
            displayName: 'SAML Authentication',
            tooltip: 'Authenticate using SAML',
            link: documentation.AUTHENTICATION.SAML,
            location: codeLocation.PROPERTY,
            code: `/* SAML Authentication Start */
             config.customAuthenticationType = microstrategy.dossier.CustomAuthenticationType.AUTH_TOKEN;
             config.enableCustomAuthentication = true;
             config.getLoginToken = async () => {
              const serverUrl = url.split("/app/")[0];
              try {
                return await microstrategy.auth.samlLogin(
                  serverUrl
                );
              } catch (e) {
                console.error(e.message);
                if (
                  e.message ===
                  "Failed to open a new tab for login or the new tab handler cannot be got. Please contact your administrator."
                ) {
                  alert(
                    "Please enable popups to be directed to the login site. Refresh the page once popups have been enabled."
                  );
                }
              }
            }
            /* SAML Authentication End */`,
          },
          {
            displayName: 'OIDC Authentication',
            tooltip: 'Authenticate using OIDC',
            link: documentation.AUTHENTICATION.SAML,
            location: codeLocation.PROPERTY,
            code: `/* OIDC Authentication Start */
             config.customAuthenticationType = microstrategy.dossier.CustomAuthenticationType.AUTH_TOKEN;
             config.enableCustomAuthentication = true;
             config.getLoginToken = async () => {
              const serverUrl = url.split("/app/")[0];
              try {
                return await microstrategy.auth.oidcLogin(
                  serverUrl
                );
              } catch (e) {
                console.error(e.message);
                if (
                  e.message ===
                  "Failed to open a new tab for login or the new tab handler cannot be got. Please contact your administrator."
                ) {
                  alert(
                    "Please enable popups to be directed to the login site. Refresh the page once popups have been enabled."
                  );
                }
              }
            }
            /* OIDC Authentication End */`,
          },
          {
            displayName: 'Guest Authentication',
            tooltip: 'Authenticate as a guest user',
            link: documentation.AUTHENTICATION.GUEST,
            location: codeLocation.PROPERTY,
            code: `/* Guest Authentication Start */
            config.customAuthenticationType = microstrategy.dossier.CustomAuthenticationType.AUTH_TOKEN;
            config.enableCustomAuthentication = true;
            config.getLoginToken = async () => {
              const serverUrl = url.split("/app/")[0];
              options = {
                method: "POST",
                credentials: "include", // Including cookie
                mode: "cors", // Setting as cors mode for cross origin
                headers: { "content-type": "application/json" },
                body: JSON.stringify({
                  loginMode: 8, // 8 means guest login
                }),
              };
              return fetch(
                serverUrl + "/api/auth/login",
                options
              ).then((response) => {
                if (response.ok) {
                  console.log(
                    "A new guest login session has been created successfully, logging in"
                  );
                  return response.headers.get("x-mstr-authtoken");
                } else response.json().then((json) => console.log(json));
              })
              .catch((error) =>
                console.error("Failed Guest Login with error:", error)
              );
            };
            /* Guest Authentication End */`,
          },
          {
            displayName: 'Standard Authentication',
            tooltip: 'Authenticate using standard mode',
            link: documentation.AUTHENTICATION.STANDARD,
            location: codeLocation.PROPERTY,
            code: `/* Standard Authentication Start */
            config.customAuthenticationType = microstrategy.dossier.CustomAuthenticationType.AUTH_TOKEN;
            config.enableCustomAuthentication = true;
            config.getLoginToken = async () => {
              const serverUrl = url.split("/app/")[0];
              async function createAuthToken() {
                // Make a call to REST API to log the user in
                const options = {
                  method: "POST",
                  credentials: "include", // Including cookie
                  mode: "cors", // Setting as cors mode for cross origin
                  headers: { "content-type": "application/json" },
                  body: JSON.stringify({
                    loginMode: 1, // 1 means Standard login
                    username: "userNamePlaceHolder", // use guest / no password to test
                    password: "passwordPlaceHolder",
                  }),
                };
    
                try {
                  const response = await fetch(
                    serverUrl + "/api/auth/login",
                    options
                  );
    
                  if (response.ok) {
                    console.log(
                      "A new standard login session has been created successfully, logging in"
                    );
                    return response.headers.get("x-mstr-authtoken");
                  } else {
                    const json = await response.json();
                    console.log(json);
                  }
                } catch (error) {
                  console.error("Failed Standard Login with error:", error);
                }
              }
              return await createAuthToken();
            };
            /* Standard Authentication End */`,
          },
          {
            displayName: 'LDAP Authentication',
            tooltip: 'Authenticate using LDAP mode',
            link: documentation.AUTHENTICATION.STANDARD,
            location: codeLocation.PROPERTY,
            code: `/* LDAP Authentication Start */
            config.customAuthenticationType = microstrategy.dossier.CustomAuthenticationType.AUTH_TOKEN;
            config.enableCustomAuthentication = true;
            config.getLoginToken = async () => {
              const serverUrl = url.split("/app/")[0];
              async function createAuthToken() {
                // Make a call to REST API to log the user in
                const options = {
                  method: "POST",
                  credentials: "include", // Including cookie
                  mode: "cors", // Setting as cors mode for cross origin
                  headers: { "content-type": "application/json" },
                  body: JSON.stringify({
                    loginMode: 16, // 16 means LDAP login
                    username: "userNamePlaceHolder", // use guest / no password to test
                    password: "passwordPlaceHolder",
                  }),
                };
    
                try {
                  const response = await fetch(
                    serverUrl + "/api/auth/login",
                    options
                  );
    
                  if (response.ok) {
                    console.log(
                      "A new LDAP login session has been created successfully, logging in"
                    );
                    return response.headers.get("x-mstr-authtoken");
                  } else {
                    const json = await response.json();
                    console.log(json);
                  }
                } catch (error) {
                  console.error("Failed LDAP Login with error:", error);
                }
              }
              return await createAuthToken();
            };
            /* LDAP Authentication End */`,
          },
          {
            displayName: 'Identity Token Authentication',
            tooltip: 'Authenticate using identity token',
            link: documentation.AUTHENTICATION.IDENTITY,
            location: codeLocation.PROPERTY,
            code: `/* Identity Authentication Start */
            config.customAuthenticationType =
            microstrategy.dossier.CustomAuthenticationType.IDENTITY_TOKEN;
            config.enableCustomAuthentication = true;
            config.getLoginToken = async function login() {
            const serverUrl = url.split("/app/")[0];
            async function createAuthToken() {
              // Make a call to REST API to log the user in
              const options = {
                method: "POST",
                credentials: "include", // Including cookie
                mode: "cors", // Setting as cors mode for cross origin
                headers: { "content-type": "application/json" },
                body: JSON.stringify({
                  loginMode: 1, // 1 means Standard login
                  username: "userNamePlaceHolder", // use guest / no password to test
                  password: "passwordPlaceHolder",
                }),
              };
  
              try {
                const response = await fetch(
                  serverUrl + "/api/auth/login",
                  options
                );
  
                if (response.ok) {
                  console.log(
                    "A new standard login session has been created successfully, logging in"
                  );
                  return response.headers.get("x-mstr-authtoken");
                } else {
                  const json = await response.json();
                  console.log(json);
                }
              } catch (error) {
                console.error("Failed Standard Login with error:", error);
              }
            }
  
            async function getIdentityToken(authToken) {
              const identityOptions = {
                method: "GET",
                credentials: "include", // Including cookie
                mode: "cors", // Setting as cors mode for cross origin
                headers: {
                  "Content-Type": "application/json",
                  "X-MSTR-AuthToken": authToken,
                },
              };
  
              try {
                const response = await fetch(
                  serverUrl + "/api/auth/identityToken",
                  identityOptions
                );
  
                if (response.ok) {
                  return response.headers.get("x-mstr-identitytoken");
                } else {
                  const json = await response.json();
                  console.log(json);
                }
              } catch (error) {
                console.error("Failed Identity Login with error:", error);
              }
            }
  
            return await getIdentityToken(await createAuthToken());
          };
          /* Identity Authentication End */`,
          },
          // {
          //   displayName: 'OAuth2 Authentication',
          //   tooltip: 'Authenticate using OAuth2',
          //   link: documentation.AUTHENTICATION.OAuth2,
          //   location: codeLocation.PROPERTY,
          //   code: `/* OAuth Authentication Start */
          //   config.customAuthenticationType =
          //     microstrategy.dossier.CustomAuthenticationType.AUTH_TOKEN;
          //   config.enableCustomAuthentication = true;
          //   config.getLoginToken = async () => {
          //     try {
          //       const serverUrl = url.split("/app/")[0];
          //       let data = await microstrategy.auth.oauthLogin(serverUrl, {
          //       clientId: 'your client id',
          //       clientSecret: 'your client secret',
          //       requireRefreshToken: true
          //       });
          //       return data.accessToken
          //     } catch (e) {
          //       console.error(e.message);
          //       if (e.message ==="Failed to open a new tab for login or the new tab handler cannot be got. Please contact your administrator.") {
          //         alert(
          //         "Please enable popups to be directed to the login site. Refresh the page once popups have been enabled."
          //         );
          //       }
          //     }
          //   };
          //   /* OAuth Authentication End */`,
          // },
        ],
      },
      {
        groupName: 'General',
        operationList: [
          {
            displayName: 'Create Dashboard',
            tooltip: 'Create a dossier',
            link: documentation.GENERAL.INTRO,
            location: codeLocation.METHOD,
            code: `/* Create Dashboard Start */
              config = {
                url: 'https://demo.microstrategy.com/MicroStrategyLibrary/app/B7CA92F04B9FAE8D941C3E9B7E0CD754/27D332AC6D43352E0928B9A1FCAF4AB0',
                placeholder: document.getElementById('${previewPanel.EMBEDDING_DOSSIER_CONTAINER_ID}'),
                enableResponsive: true
              }
              try {
                dossier = await microstrategy.dossier.create(config);
              } catch(error) {
                // Your custom error handling logic here
                console.error(error);
              }
              /* Create Dashboard End */`,
          },
          {
            displayName: 'Remove Dashboard',
            tooltip: 'Destroy the dashboard iframe from the placeholder div',
            location: codeLocation.METHOD,
            link: documentation.PROPERTIES.GENERAL,
            code: `/* Remove Dashboard Start */
                microstrategy.dossier.destroy({
                  placeholder: document.getElementById('${previewPanel.EMBEDDING_DOSSIER_CONTAINER_ID}')
                })
              /* Remove Dashboard End */`,
          },
          {
            displayName: 'Open Dashboard in Library',
            tooltip:
              'Opens the dashboard thats currently embedding into library with same features conditions',
            link: documentation.PROPERTIES.GENERAL,
            location: codeLocation.METHOD,
            code: `/* Open Dashboard in Library Start */
            function openInLibrary(url, config) {
              // Initialize the configuration settings to open dashboard in library
              var dossierURL = url
              var enableCollaboration = config.enableCollaboration
              var navBar = config.navigationBar
              var filterFeature = config.filterFeature
              var shareFeature = config.shareFeature
              var optionsFeature = config.optionsFeature
              // Use library url api to open the dossier. See https://www2.microstrategy.com/producthelp/Current/WebSDK/Content/topics/urlapi/URL_API.htm.
              var src = dossierURL+'?'
                +'app.embedding='+false
                +'&app.enableCollaboration='+enableCollaboration
                +'&feature.filter='+filterFeature.enabled
                +'&feature.filter.edit='+filterFeature.edit
                +'&feature.filter.summary='+filterFeature.summary
                +'&ui.navigation='+navBar.enabled
                +'&ui.navigation.gotoLibrary='+navBar.gotoLibrary
                +'&ui.navigation.toc='+navBar.toc
                +'&ui.navigation.reset='+navBar.reset
                +'&ui.navigation.title='+navBar.title
                +'&ui.navigation.share='+navBar.share
                +'&ui.navigation.comment='+navBar.comment
                +'&ui.navigation.filter='+navBar.filter
                +'&feature.share='+shareFeature.enabled
                +'&feature.share.invite='+shareFeature.invite
                +'&feature.share.link='+shareFeature.link
                +'&feature.share.email='+shareFeature.email
                +'&feature.share.export='+shareFeature.export
                +'&feature.share.download='+shareFeature.download
                +'&feature.option='+optionsFeature.enabled
                +'&feature.option.help='+optionsFeature.help
                +'&feature.option.logout='+optionsFeature.logout
                +'&feature.option.manage='+optionsFeature.manage
                +'&feature.option.showTutorials='+optionsFeature.showTutorials
              window.open(src)
            }
            openInLibrary(url, config)
            /* Open Dashboard in Library End */`,
          },
          {
            displayName: 'Retrieve Dashboard Instance Id',
            tooltip: 'Retrieve the dashboard instance id',
            location: codeLocation.METHOD,
            link: documentation.PROPERTIES.GENERAL,
            code: `/* Retrieve Dashboard Instance Id Start */
            dossier
              .getDossierInstanceId()
              .then((id) => console.log("The dashboard instance id is:" + id))
              .catch((error) => {
                console.error(error);
              });
            /* Retrieve Dashboard Instance Id End */`,
          },
        ],
      },
      {
        groupName: 'Error',
        operationList: [
          {
            displayName: 'Add Custom Error Handler On Dashboard Creation',
            tooltip: 'The error handler used during dashboard creation',
            link: documentation.ERROR.DURING_DOSSIER_CREATION,
            location: codeLocation.PROPERTY,
            code: `/* Add Custom Error Handler On Dashboard Creation Start*/
              config.errorHandler = function customErrorHandler(error) {
                /* Add any functionality for handling event here */
                console.log('Catch error: ' + error.message);
              }
              config.disableCustomErrorHandlerOnCreate = false
              /* Add Custom Error Handler On Dashboard Creation End*/`,
          },
          {
            displayName: 'Add Custom Error Handler After Dashboard Creation',
            tooltip: 'You can also provide error handling after the dashboard is created',
            link: documentation.ERROR.AFTER_DOSSIER_CREATION,
            location: codeLocation.METHOD,
            code: `/* Add Custom Error Handler After Dashboard Creation Start */
              // addCustomErrorHandler(callback:function, showPopUp:boolean)
              dossier.addCustomErrorHandler(function customErrorHandler(error) {
                /* Add any functionality for handling event here */
                console.log('Catch error: ' + error.message);
              }, false);
              /* Add Custom Error Handler After Dashboard Creation End */`,
          },
          {
            displayName: 'Remove Custom Error Handler After Dashboard Creation',
            tooltip: 'Show to remove customer error handling',
            link: documentation.ERROR.AFTER_DOSSIER_CREATION,
            location: codeLocation.METHOD,
            code: `/* Remove Custom Error Handler After Dashboard Creation Start */
            dossier.removeCustomErrorHandler();
            /* Remove Custom Error Handler After Dashboard Creation End */`,
          },
        ],
      },
      {
        groupName: 'Events',
        operationList: [
          {
            displayName: 'On Error Event',
            tooltip: 'Raised when error occurs',
            link: documentation.EVENTS.GENERAL,
            location: codeLocation.METHOD,
            code: `/* On Error Event Start */
              function eventErrorFunction(e) {
                // Add any functionality for event needed here
                console.log('On Error Event');
              }
              dossier.registerEventHandler(microstrategy.dossier.EventType.ON_ERROR, eventErrorFunction);

              // To remove the event handler, use the code in comment below
              // dossier.removeEventHandler(microstrategy.dossier.EventType.ON_ERROR, eventErrorFunction);
              /* On Error Event End */`,
          },
          {
            displayName: 'On Session Error Event',
            tooltip: 'Raised when session error occurs',
            link: documentation.ERROR.AFTER_DOSSIER_CREATION,
            location: codeLocation.METHOD,
            code: `/* On Session Error Event Start */
              function eventSessionErrorFunction(e) {
                // Add any functionality for event needed here
                console.log('On Session Error Event');
              }
              dossier.addSessionErrorHandler(eventSessionErrorFunction);

              // To remove the event handler, use the code in comment below 
              // dossier.removeSessionErrorhandler()
              /* On Session Error Event End */`,
          },
          {
            displayName: 'On Filter Updated Event',
            tooltip: 'Raised when a filter is changed',
            link: documentation.EVENTS.GENERAL,
            location: codeLocation.METHOD,
            code: `/* On Filter Updated Event Start*/
            function eventFilterUpdatedFunction(e) {
              // Add any functionality for event needed here
              console.log('Filter Updated Event');
            }
            dossier.registerEventHandler(microstrategy.dossier.EventType.ON_FILTER_UPDATED, eventFilterUpdatedFunction);

            // To remove the event handler, use the code in comment below
            // dossier.removeEventHandler(microstrategy.dossier.EventType.ON_FILTER_UPDATED, eventFilterUpdatedFunction);
            /* On Filter Updated Event End */`,
          },
          {
            displayName: 'On Graphics Selected Event',
            tooltip: 'Raised when a graphic in the visualization is selected',
            link: documentation.EVENTS.GENERAL,
            location: codeLocation.METHOD,
            code: `/* On Graphics Selected Event Start*/
              function eventGraphicsSelectedFunction(e) {
                // Add any functionality for event needed here
                console.log('Graphics Selected Event');
              }
              dossier.registerEventHandler(microstrategy.dossier.EventType.ON_GRAPHICS_SELECTED, eventGraphicsSelectedFunction);

              // To remove the event handler, use the code in comment below
              // dossier.removeEventHandler(microstrategy.dossier.EventType.ON_GRAPHICS_SELECTED, eventGraphicsSelectedFunction);
              /* On Graphics Selected Event End*/`,
          },
          {
            displayName: 'On Page Switched Event',
            tooltip: 'Raised when the page is switched',
            link: documentation.EVENTS.GENERAL,
            location: codeLocation.METHOD,
            code: `/* On Page Switched Event Start*/
              function eventPageSwitchedFunction(e) {
                // Add any functionality for event needed here
                console.log('Page Switched Event');
              }
              dossier.registerEventHandler(microstrategy.dossier.EventType.ON_PAGE_SWITCHED, eventPageSwitchedFunction);

              // To remove the event handler, use the code in comment below
              // dossier.removeEventHandler(microstrategy.dossier.EventType.ON_PAGE_SWITCHED, eventPageSwitchedFunction);
              /* On Page Switched Event End*/`,
          },
          {
            displayName: 'On Page Load Event',
            tooltip: 'Raised when the page is loaded.',
            link: documentation.EVENTS.GENERAL,
            location: codeLocation.METHOD,
            code: `/* On Page Load Event Start*/
              function eventPageLoadedFunction(e) {
                // Add any functionality for event needed here
                console.log('Page Load Event');
              }
              dossier.registerEventHandler(microstrategy.dossier.EventType.ON_PAGE_LOADED, eventPageLoadedFunction);

              // To remove the event handler, use the code in comment below
              // dossier.removeEventHandler(microstrategy.dossier.EventType.ON_PAGE_LOADED, eventPageLoadedFunction);
              /* On Page Load Event End*/`,
          },
          {
            displayName: 'On Layout Changed Event',
            tooltip: 'Raised when the layout changed.',
            link: documentation.EVENTS.GENERAL,
            location: codeLocation.METHOD,
            code: `/* On Layout Changed Event Start*/
              function eventLayoutChangedFunction(e) {
                // Add any functionality for event needed here
                console.log('Layout Changed Event');
              }
              dossier.registerEventHandler(microstrategy.dossier.EventType.ON_LAYOUT_CHANGED, eventLayoutChangedFunction);

              // To remove the event handler, use the code in comment below
              // dossier.removeEventHandler(microstrategy.dossier.EventType.ON_LAYOUT_CHANGED, eventLayoutChangedFunction);
              /* On Layout Changed Event End*/`,
          },
          {
            displayName: 'On Prompt Answered Event',
            tooltip: 'Raised when the prompt is answered.',
            link: documentation.EVENTS.GENERAL,
            location: codeLocation.METHOD,
            code: `/* On Prompt Answered Event Start*/
              function eventPromptAnsweredFunction(e) {
                // Add any functionality for event needed here
                console.log('Prompt Answered Event');
              }
              dossier.registerEventHandler(microstrategy.dossier.EventType.ON_PROMPT_ANSWERED, eventPromptAnsweredFunction);

              // To remove the event handler, use the code in comment below
              // dossier.removeEventHandler(microstrategy.dossier.EventType.ON_PROMPT_ANSWERED, eventPromptAnsweredFunction);
              /* On Prompt Answered Event End*/`,
          },
          {
            displayName: 'On Prompt Loaded Event',
            tooltip: 'Raised when the prompt is loaded.',
            link: documentation.EVENTS.GENERAL,
            location: codeLocation.METHOD,
            code: `/* On Prompt Loaded Event Start*/
              function eventPromptLoadedFunction(e) {
                // Add any functionality for event needed here
                console.log('Prompt Loaded Event');
              }
              dossier.registerEventHandler(microstrategy.dossier.EventType.ON_PROMPT_LOADED, eventPromptLoadedFunction);

              // To remove the event handler, use the code in comment below
              // dossier.removeEventHandler(microstrategy.dossier.EventType.ON_PROMPT_LOADED, eventPromptLoadedFunction);
              /* On Prompt Loaded Event End*/`,
          },
          {
            displayName: 'On Visualization Selection Changed Event',
            tooltip: 'Raised when the visualization selection changed.',
            link: documentation.EVENTS.GENERAL,
            location: codeLocation.METHOD,
            code: `/* On Visualization Selection Changed Event Start*/
              function eventVizSelectionChangedFunction(e) {
                // Add any functionality for event needed here
                console.log('Visualization Selection Changed Event');
              }
              dossier.registerEventHandler(microstrategy.dossier.EventType.ON_VIZ_SELECTION_CHANGED, eventVizSelectionChangedFunction);

              // To remove the event handler, use the code in comment below
              // dossier.removeEventHandler(microstrategy.dossier.EventType.ON_VIZ_SELECTION_CHANGED, eventVizSelectionChangedFunction);
              /* On Visualization Selection Changed Event End*/`,
          },
          {
            displayName: 'On Dashboard Instance ID Changed Event',
            tooltip: 'Raised when the Dashboard instance ID changed.',
            link: documentation.EVENTS.GENERAL,
            location: codeLocation.METHOD,
            code: `/* On Dashboard Instance ID Change Event Start*/
              function eventDossierInstanceIdChangedFunction(e) {
                // Add any functionality for event needed here
                console.log('Dashboard Instance ID Changed Event');
              }
              dossier.registerEventHandler(microstrategy.dossier.EventType.ON_DOSSIER_INSTANCE_ID_CHANGE, eventDossierInstanceIdChangedFunction);

              // To remove the event handler, use the code in comment below
              // dossier.removeEventHandler(microstrategy.dossier.EventType.ON_DOSSIER_INSTANCE_ID_CHANGE, eventDossierInstanceIdChangedFunction);
              /* On Dashboard Instance ID Changed Event End*/`,
          },
          {
            displayName: 'On Visualization Resized Event',
            tooltip: 'Raised when a visualization is resized',
            link: documentation.EVENTS.GENERAL,
            location: codeLocation.METHOD,
            code: `/* On Visualization Resized Event Start */
              function eventVisualizationResizedFunction(e) {
                // Add any functionality for event needed here
                console.log('Visualization Resized Event');
              }
              dossier.registerEventHandler(microstrategy.dossier.EventType.ON_VISUALIZATION_RESIZED, eventVisualizationResizedFunction);

              // To remove the event handler, use the code in comment below
              // dossier.removeEventHandler(microstrategy.dossier.EventType.ON_VISUALIZATION_RESIZED, eventVisualizationResizedFunction);
              /* On Visualization Resized Event End */`,
          },
          {
            displayName: 'On Panel Switched Event',
            tooltip: 'Raised when a panel is switched',
            link: documentation.EVENTS.GENERAL,
            location: codeLocation.METHOD,
            code: `/* On Panel Switched Event Start */
              function eventPanelSwitchedFunction(e) {
                // Add any functionality for event needed here
                console.log('Panel Switched Event');
              }
              dossier.registerEventHandler(microstrategy.dossier.EventType.ON_PANEL_SWITCHED, eventPanelSwitchedFunction);

              // To remove the event handler, use the code in comment below
              // dossier.removeEventHandler(microstrategy.dossier.EventType.ON_PANEL_SWITCHED, eventPanelSwitchedFunction);
              /* On Panel Switched Event End */`,
          },
          {
            displayName: 'On Visualization Element Changed Event',
            tooltip: 'Raised when a visualization element changed.',
            link: documentation.EVENTS.GENERAL,
            location: codeLocation.METHOD,
            code: `/* On Visualization Element Changed Event Start */
              function eventVizElementChangedFunction(e) {
                // Add any functionality for event needed here
                console.log('Visualization Element Changed Event');
              }
              dossier.registerEventHandler(microstrategy.dossier.EventType.ON_VIZ_ELEMENT_CHANGED, eventVizElementChangedFunction);

              // To remove the event handler, use the code in comment below
              // dossier.removeEventHandler(microstrategy.dossier.EventType.ON_VIZ_ELEMENT_CHANGED, eventVizElementChangedFunction);
              /* On Visualization Element Changed Event End */`,
          },
          {
            displayName: 'On Dashboard Authoring Saved Event',
            tooltip: 'Raised when dashboard authoring saved.',
            link: documentation.EVENTS.GENERAL,
            location: codeLocation.METHOD,
            code: `/* On Dashboard Authoring Saved Event Start */
              function eventDossierAuthoringSavedFunction(e) {
                // Add any functionality for event needed here
                console.log('Dashboard Authoring Saved Event');
              }
              dossier.registerEventHandler(microstrategy.dossier.EventType.ON_DOSSIER_AUTHORING_SAVED, eventDossierAuthoringSavedFunction);

              // To remove the event handler, use the code in comment below
              // dossier.removeEventHandler(microstrategy.dossier.EventType.ON_DOSSIER_AUTHORING_SAVED, eventDossierAuthoringSavedFunction);
              /* On Dashboard Authoring Saved Event End */`,
          },
          {
            displayName: 'On Dashboard Authoring Closed Event',
            tooltip: 'Raised when dashboard authoring closed.',
            link: documentation.EVENTS.GENERAL,
            location: codeLocation.METHOD,
            code: `/* On Dashboard Authoring Closed Event Start */
              function eventDossierAuthoringClosedFunction(e) {
                // Add any functionality for event needed here
                console.log('Dashboard Authoring Closed Event');
              }
              dossier.registerEventHandler(microstrategy.dossier.EventType.ON_DOSSIER_AUTHORING_CLOSED, eventDossierAuthoringClosedFunction);

              // To remove the event handler, use the code in comment below
              // dossier.removeEventHandler(microstrategy.dossier.EventType.ON_DOSSIER_AUTHORING_CLOSED, eventDossierAuthoringClosedFunction);
              /* On Dashboard Authoring Closed Event End */`,
          },
          {
            displayName: 'On Page Render Finished Event',
            tooltip: 'Raised when page render finished.',
            link: documentation.EVENTS.GENERAL,
            location: codeLocation.METHOD,
            code: `/* On Page Render Finished Event Start */
              function eventPageRenderFinishedFunction(e) {
                // Add any functionality for event needed here
                console.log('Page Render Finished Event');
              }
              dossier.registerEventHandler(microstrategy.dossier.EventType.ON_PAGE_RENDER_FINISHED, eventPageRenderFinishedFunction);

              // To remove the event handler, use the code in comment below
              // dossier.removeEventHandler(microstrategy.dossier.EventType.ON_PAGE_RENDER_FINISHED, eventPageRenderFinishedFunction);
              /* On Page Render Finished Event End */`,
          },
          {
            displayName: 'On Library Page Loaded Event',
            tooltip: 'Raised when library page is loaded',
            link: documentation.EVENTS.GENERAL,
            location: codeLocation.METHOD,
            code: `/* On Library Page Loaded Event Start */
              function eventLibraryPageLoadedFunction(e) {
                // Add any functionality for event needed here
                console.log('Library Page Loaded Event');
              }
              dossier.registerEventHandler(microstrategy.dossier.EventType.ON_LIBRARY_PAGE_LOADED, eventLibraryPageLoadedFunction);

              // To remove the event handler, use the code in comment below
              // dossier.removeEventHandler(microstrategy.dossier.EventType.ON_LIBRARY_PAGE_LOADED, eventLibraryPageLoadedFunction);
              /* On Library Page Loaded Event End */`,
          },
          {
            displayName: 'On Embed Location Changed Event',
            tooltip: 'Raised when the embed location changes',
            link: documentation.EVENTS.GENERAL,
            location: codeLocation.METHOD,
            code: `/* On Embed Location Changed Event Start */
              function eventEmbedLocationChangedFunction(e) {
                // Add any functionality for event needed here
                console.log('Embed Location Changed Event');
              }
              dossier.registerEventHandler(microstrategy.dossier.EventType.ON_EMBED_LOCATION_CHANGED, eventEmbedLocationChangedFunction);

              // To remove the event handler, use the code in comment below
              // dossier.removeEventHandler(microstrategy.dossier.EventType.ON_EMBED_LOCATION_CHANGED, eventEmbedLocationChangedFunction);
              /* On Embed Location Changed Event End */`,
          },
          {
            displayName: 'On Embed Page Loaded Event',
            tooltip: 'Raised when the embedded page is loaded',
            link: documentation.EVENTS.GENERAL,
            location: codeLocation.METHOD,
            code: `/* On Embed Page Loaded Event Start */
              function eventEmbedPageLoadedFunction(e) {
                // Add any functionality for event needed here
                console.log('Embed Page Loaded Event');
              }
              dossier.registerEventHandler(microstrategy.dossier.EventType.ON_EMBED_PAGE_LOADED, eventEmbedPageLoadedFunction);

              // To remove the event handler, use the code in comment below
              // dossier.removeEventHandler(microstrategy.dossier.EventType.ON_EMBED_PAGE_LOADED, eventEmbedPageLoadedFunction);
              /* On Embed Page Loaded Event End */`,
          },
        ],
      },
      {
        groupName: 'Navigation',
        operationList: [
          {
            displayName: 'Get Table of Contents',
            tooltip: 'Get the table of contents in the dossier',
            link: documentation.NAVIGATION.GET_TABLE_CONTENT,
            location: codeLocation.METHOD,
            code: `/* Get Table of Contents Start */
            var toc = dossier.getTableContent()
            console.log('Get Table of Contents:', toc)
            /* Get Table of Contents End */`,
          },
          {
            displayName: 'Get a List of Chapters',
            tooltip: 'Get a list of chapters in the dossier',
            link: documentation.NAVIGATION.GET_CHAPTER_LIST,
            location: codeLocation.METHOD,
            code: `/* Get a List of Chapters Start */
              var listOfChapters = dossier.getChapterList()
              console.log('Get a List of Chapters:',listOfChapters)
            /* Get a List of Chapters End */`,
          },
          {
            displayName: 'Get Page by Node Key',
            tooltip: 'Get the page by its node key',
            link: documentation.NAVIGATION.GET_PAGE_BY_NODE_KEY,
            location: codeLocation.METHOD,
            code: `/* Get Page by Node Key Start */
            var page = dossier.getPageByNodeKey('W93--K78') // Replace with the node key of page you want
            console.log('Get Page by Node Key:', page)
            /* Get Page by Node Key End */`,
          },
          {
            displayName: 'Navigate to First Page',
            tooltip: 'Switch to the first page of the dossier',
            link: documentation.NAVIGATION.NAVIGATE_TO_PAGE,
            location: codeLocation.METHOD,
            code: `/* Navigate to First Page of Dashboard Start */
                var firstChapter = dossier.getChapterList()[0]
                dossier.navigateToPage(dossier.getChapterList()[0].getFirstPage())
              /* Navigate to Last Page of Dashboard End */`,
          },
          {
            displayName: 'Navigate to Previous Page',
            tooltip: 'Switch to the previous page of the dossier',
            link: documentation.NAVIGATION.GO_TO_PREV_PAGE,
            location: codeLocation.METHOD,
            code: `/* Navigate to Previous Page Start */
                dossier.goToPrevPage()
              /* Navigate to Previous Page End */`,
          },
          {
            displayName: 'Navigate to Next Page',
            tooltip: 'Switch to the next page of the dossier',
            link: documentation.NAVIGATION.GO_TO_NEXT_PAGE,
            location: codeLocation.METHOD,
            code: `/* Navigate to Next Page Start*/
              dossier.goToNextPage()
              /* Navigate to Next Page End */`,
          },
          {
            displayName: 'Navigate to Last Page',
            tooltip: 'Switch to the last page of the dossier',
            link: documentation.NAVIGATION.NAVIGATE_TO_PAGE,
            location: codeLocation.METHOD,
            code: `/* Navigate to Last Page of Dashboard Start */
                var chapters = dossier.getChapterList()
                var lastChapter = chapters[chapters.length - 1]
                dossier.navigateToPage(lastChapter.getLastPage())
              /* Navigate to Last Page of Dashboard End */`,
          },
          {
            displayName: 'Navigate to First Chapter',
            tooltip: 'Switch to the first chapter of the dossier',
            link: documentation.NAVIGATION.NAVIGATE_TO_PAGE,
            location: codeLocation.METHOD,
            code: `/* Navigate to First Chapter of Dashboard Start */
                var firstChapter = dossier.getChapterList()[0]
                dossier.navigateToPage(firstChapter.getFirstPage())
              /* Navigate to First Chapter of Dashboard End */`,
          },
          {
            displayName: 'Navigate to Previous Chapter',
            tooltip: 'Switch to the previous chapter of the dossier',
            link: documentation.NAVIGATION.NAVIGATE_TO_PAGE,
            location: codeLocation.METHOD,
            code: `/* Navigate to Previous Chapter Start */
                var previousChapter = dossier.getCurrentChapter().getPrevChapter()
                dossier.navigateToPage(previousChapter.getFirstPage())
              /* Navigate to Previous Chapter End */`,
          },
          {
            displayName: 'Navigate to Next Chapter',
            tooltip: 'Switch to the next chapter of the dossier',
            link: documentation.NAVIGATION.NAVIGATE_TO_PAGE,
            location: codeLocation.METHOD,
            code: `/*  Navigate to Next Chapter Start */
                var nextChapter = dossier.getCurrentChapter().getNextChapter()
                dossier.navigateToPage(nextChapter.getFirstPage())
              /* Navigate to Next Chapter End */`,
          },
          {
            displayName: 'Navigate to Last Chapter',
            tooltip: 'Switch to the last chapter of the dossier',
            link: documentation.NAVIGATION.NAVIGATE_TO_PAGE,
            location: codeLocation.METHOD,
            code: `/* Navigate to Last Chapter of Dashboard Start */
                var chapters = dossier.getChapterList()
                var lastChapter = chapters[chapters.length - 1]
                dossier.navigateToPage(lastChapter.getFirstPage())
              /* Navigate to Last Chapter of Dashboard End */`,
          },
        ],
      },
      {
        groupName: 'Properties',
        operationList: [
          {
            displayName: 'Dashboard Layout',
            tooltip: 'Show dashboard layout configurations',
            link: documentation.PROPERTIES.GENERAL,
            location: codeLocation.PROPERTY,
            code: `/* Edit Dashboard Layout Start */
                config.containerHeight = '600px' // Set the height of the placeholder.
                config.containerWidth = '800px' // Set the width of the placeholder.
                config.enableResponsive = true // Adjust dashboard to fit placeholder ignores container width.
              /* Edit Dashboard Layout End */`,
          },
          {
            displayName: 'Comments Layout',
            tooltip: 'Show comments layout configurations',
            link: documentation.PROPERTIES.GENERAL,
            location: codeLocation.PROPERTY,
            code: `/* Edit Comments Layout Start */
              config.dockedComment = {
                dockedPosition: 'left', // Only 'left' or 'right' is accepted as the position of the docked panel.
                canClose: false, // Boolean. If set to false, the panel is forced to appear.
                dockChangeable: false, // Boolean. If set to false, the dock/pin button is hidden. The docked status of this panel is controlled by isDocked.
                isDocked: true, // Boolean. This configures whether the panel is docked.
                }
              /* Edit Comments Layout End */`,
          },
          {
            displayName: 'Filters Layout',
            tooltip: 'Show filters layout configurations',
            link: documentation.PROPERTIES.GENERAL,
            location: codeLocation.PROPERTY,
            code: `/* Edit Filters Layout Start */
              config.dockedFilter = {
                dockedPosition: 'left', // Only 'left' or 'right' is accepted as the position of the docked panel.
                canClose: false, // Boolean. If set to false, the panel is forced to appear.
                dockChangeable: false, // Boolean. If set to false, the dock/pin button is hidden. The docked status of this panel is controlled by isDocked.
                isDocked: true, // Boolean. This configures whether the panel is docked.
                }
              config.filterFeature = {
                enabled: true, // Boolean. Enable or disable filter features.
                edit: false, // Boolean. Show or hide the filter edit function. Enable or disable editing on the filter panel.
                summary: true // Boolean. Show or hide the filter summary bar.
              }
              /* Edit Filters Layout End */`,
          },
          {
            displayName: 'Table of Contents Layout',
            tooltip: 'Show table of content layout configurations',
            link: documentation.PROPERTIES.GENERAL,
            location: codeLocation.PROPERTY,
            code: `/* Edit Table of Contents Layout Start */
                config.dockedTOC = {
                dockedPosition: 'left', // Only 'left' or 'right' is accepted as the position of the docked panel.
                theme: 'light', // Only 'dark' or 'light' theme is accepted.
                canClose: false, // Boolean. If set to false, the panel is forced to appear.
                dockChangeable: false, // Boolean. If set to false, the dock/pin button is hidden. The docked status of this panel is controlled by isDocked.
                isDocked: true // Boolean. This configures whether the panel is docked.
                }
                /* Edit Table of Contents Layout End */`,
          },
          {
            displayName: 'Navigation Bar Layout',
            tooltip: 'Show navigation bar layout configurations',
            link: documentation.PROPERTIES.GENERAL,
            location: codeLocation.PROPERTY,
            code: `/* Edit Navigation Bar Start */
                config.navigationBar = {
                  enabled: true, // Enable or disable the navigation bar.
                  edit: true, // Show or hide the edit icon.
                  gotoLibrary: false, // Show or hide the gotoLibrary icon.
                  title: false, // Show or hide the dashboard title.
                  toc: true, // Show or hide the table of contents icon.
                  share: false, // Show or hide the share icon.
                  comment: true, // Show or hide the comment icon.
                  notification: false, // Show or hide the notification icon.
                  filter: true, // Show or hide the filter icon.
                  options: true, // Show or hide the options icon.
                  search: false, // Show or hide the search icon.
                  bookmark: true, // Show or hide the bookmark icon.
                  reset: true, // Show or hide the reset icon.
                  reprompt: false // Show or hide the reprompt icon.
                }
                /* Edit Navigation Bar End */`,
          },
          {
            displayName: 'Collaboration',
            tooltip: 'Show collaboration configurations',
            link: documentation.PROPERTIES.GENERAL,
            location: codeLocation.PROPERTY,
            code: `/* Edit Collaboration Start */
                config.enableCollaboration = true // Use this Boolean property to enable or disable collaboration-related controls of Library.
                /* Edit Collaboration End */`,
          },
          {
            displayName: 'Options',
            tooltip: 'Show options configurations',
            link: documentation.PROPERTIES.GENERAL,
            location: codeLocation.PROPERTY,
            code: `/* Edit Options Start */
                config.optionsFeature = {
                enabled: true, // Enable or disable the options features.
                help: false, // Show or hide help functionality.
                logout: true, // Show or hide the logout functionality.
                manage: false, // Show or hide manage functionality.
                showTutorials: true // Show or hide tutorial functionality.
                }
                /* Edit Options End */`,
          },
          {
            displayName: 'Share',
            tooltip: 'Show sharing configurations',
            link: documentation.PROPERTIES.GENERAL,
            location: codeLocation.PROPERTY,
            code: `/* Edit Share Start */
                config.shareFeature = {
                enabled: true, // Enable or disable share features.
                invite: false, // Show or hide invite functionality.
                link: true, // Show or hide link functionality.
                email: false, // Show or hide email functionality.
                export: true, // Show or hide export functionality.
                download: false, // Show or hide download functionality.
                shareDossier: false, // Show or hide share dashboard functionality.
                subscribe: false, // Show or hide subscribe functionality.
                }
                /* Edit Share End */`,
          },
          {
            displayName: 'UI Message',
            tooltip: 'Show UI message configurations',
            link: documentation.PROPERTIES.GENERAL,
            location: codeLocation.PROPERTY,
            code: `/* Edit UI Message Start */
            config.uiMessage = {
              enabled: true, // Boolean. Enable or disable all messages.
              addToLibrary: true // Boolean. Show or hide the addToLibrary message.
            }
            /* Edit UI Message End */`,
          },
          {
            displayName: 'Library Page Layout',
            tooltip: 'Show Library home page layout configurations',
            link: documentation.PROPERTIES.GENERAL,
            location: codeLocation.PROPERTY,
            code: `/* Edit Library Page Start */
            config.customUi = {
              ...config.customUi,
              library: {
                navigationBar: {
                  enabled: true, // Show or hide the navigation bar.
                  sortAndFilter: true, // Show or hide the library filter icon and the search bar.
                  title: true, // Show or hide the title.
                  searchBar: true, // Show or hide the search bar.
                  createNew: {
                    enabled: true, // Show or hide the "Create New" button.
                  },
                  notifications: true, // Show or hide the notification button.
                  multiSelect: {
                    enabled: true, // Show or hide the multi-select button.
                  },
                  account: {
                    enabled: true, // Show or hide the account button.
                  },
                },
                sidebar: {
                  enabled: true, // Show or hide the "show sidebar" icon.
                  show: false, // Show or hide the sidebar. sidebar.enabled must be "true" and custom application must have this enabled to show.
                }
              }
            }
            /* Edit Library Page End */`,
          },
        ],
      },
      {
        groupName: 'Panel Stacks',
        operationList: [
          {
            displayName: 'Get Current Page Panel Stacks',
            tooltip: 'Get the panel stacks on the current page',
            link: documentation.PANEL_STACKS.GENERAL,
            location: codeLocation.METHOD,
            code: ` /*  Get Current Page Panel Stacks Start */
            dossier.getCurrentPagePanelStacks().then((currentPagePanelStacks) => {
              console.log('Get Current Page Panel Stacks:', currentPagePanelStacks)
              return currentPagePanelStacks
            }).catch((error) => {
              console.error(error)
            })
            /*  Get Current Page Panel Stacks End */`,
          },
          {
            displayName: 'Switch Panel',
            tooltip: 'Switch from the current panel to the selected panel',
            link: documentation.PANEL_STACKS.GENERAL,
            location: codeLocation.METHOD,
            code: `/*  Switch Panels Start */
            // Switch the panelKeyHere to the panel you want to switch to
            dossier.switchPanel(panelKeyHere).then((switchPanel) => {
              console.log('Panel switched to ', switchPanel)
            }).catch((error) => {
              console.error(error)
            })
            /*  Switch Panels End */`,
          },
        ],
      },
      {
        groupName: 'Filters',
        operationList: [
          {
            displayName: 'Open Filter Summary Bar',
            tooltip: 'Opens the filter summary bar',
            link: documentation.NAVIGATION.OPEN_FILTER_SUMMARY_BAR,
            location: codeLocation.METHOD,
            code: `/* Open Filter Summary Bar Start */
            dossier.openFilterSummaryBar()
            /* Open Filter Summary Bar End */`,
          },
          {
            displayName: 'Close Filter Summary Bar',
            tooltip: 'Closes the filter summary bar',
            link: documentation.NAVIGATION.CLOSE_FILTER_SUMMARY_BAR,
            location: codeLocation.METHOD,
            code: `/* Close Filter Summary Bar Start */
            dossier.closeFilterSummaryBar()
            /* Close Filter Summary Bar End */`,
          },
          {
            displayName: 'Get List of Filters',
            tooltip: 'Get an array of filters from the current chapter in dossier',
            link: documentation.FILTERS.RETRIEVE_FILTERS,
            location: codeLocation.METHOD,
            code: `/* Get List of Filters Start */
              dossier.getFilterList().then((filterList) => {
                console.log('Get List of Filters:', filterList)
              }).catch((error) => {
                console.error(error)
              })
              /* Get List of Filters End */`,
          },
          {
            displayName: 'Apply a Filter On Dashboard Creation ',
            tooltip: 'Apply a filter to the dashboard on dashboard creation',
            link: documentation.FILTERS.APPLY_FILTERS,
            location: codeLocation.PROPERTY,
            code: `/* Apply a Filter On Dashboard Creation Start */
            config.filters = [
              {
                key: 'W395', // Replace with the key of the filter that is being edited
                selections: [
                  {
                    id: 'hCoffee;68BC129B11EAC2895CE50080EFD50315' // Replace with value of selection
                  },
                  {
                    id: 'hComputers;68BC129B11EAC2895CE50080EFD50315' // Replace with value of selection
                  }
                ]
              }
            ]
            /* Apply a Filter On Dashboard Creation End */`,
          },
          {
            displayName: 'Apply a Filter After Dashboard Creation',
            tooltip: 'Apply a filter to the dashboard after dashboard creation',
            link: documentation.FILTERS.APPLY_FILTERS,
            location: codeLocation.METHOD,
            code: `/* Apply a Filter After Dashboard Creation Start */

            dossier.filterSelectMultiAttributes({
              filterInfo: {
                key: 'W395' // Replace with the key of the filter that is being edited
              },
              selections: [
                {
                  value: 'hCoffee;68BC129B11EAC2895CE50080EFD50315' // Replace with value of selection
                },
                {
                  value: 'hComputers;68BC129B11EAC2895CE50080EFD50315' // Replace with value of selection
                }
              ],
              holdSubmit: true
            })
            dossier.filterApplyAll()
            /* Apply a Filter After Dashboard Creation End */`,
          },
          {
            displayName: 'Select All Attributes for the Filter',
            tooltip:
              'Select all the attributes for the filter with "key" and apply the change immediately.',
            link: documentation.FILTERS.APPLY_FILTERS,
            location: codeLocation.METHOD,
            code: `/* Select All Attributes for the Filter Start */
              dossier.filterSelectAllAttributes({
                filterInfo: {
                  key: 'FILTER_KEY'  // Replace with the key of the filter that is being edited.
                },
                holdSubmit: false
              });
              /* Select All Attributes for the Filter End */`,
          },
          {
            displayName: 'Deselect All Attributes for the Filter',
            tooltip:
              'Deselect all the attributes for the filter with "key" and save the change to client side.',
            link: documentation.FILTERS.APPLY_FILTERS,
            location: codeLocation.METHOD,
            code: `/* Deselect All Attributes for the Filter */
              dossier.filterDeselectAllAttributes({
                filterInfo: {
                  key: 'FILTER_KEY'  // Replace with the key of the filter that is being edited.
                },
                holdSubmit: true  // Need to run 'dossier.filterApplyAll()' to apply changes.
              });
              /* Deselect All Attributes for the Filter End */`,
          },
          {
            displayName: 'Select Single Filter Attribute',
            tooltip:
              'Select single attributes for the filter with "key". Use either "name" or "value" to do the selection. "value" is the attribute element ID. You can get it from the "getFilterList" API. "name" should be the attribute element name, if you provide the name, it is converted to a value (ID).',
            link: documentation.FILTERS.APPLY_FILTERS,
            location: codeLocation.METHOD,
            code: `/* Select Single Filter Attribute Start */
              dossier.filterSelectSingleAttribute({
                filterInfo: {
                  key: 'FILTER_KEY'  // Replace with the key of the filter that is being edited.
                },
                selection: {
                    value: 'VALUE_SELECTION'  // Replace with value of selection.
                    // or use 'name' instead (comment the line above and uncomment the line below).
                    // name: 'NAME_SELECTION'  // Replace with value of selection.
                  },
                holdSubmit: false
              });
              /* Select Single Filter Attribute End */`,
          },
          {
            displayName: 'Select Multiple Attributes for the Filter',
            tooltip: 'Select multiple attributes for the filter with "key".',
            link: documentation.FILTERS.APPLY_FILTERS,
            location: codeLocation.METHOD,
            code: `/* Select Multiple Attributes for the Filter Start */
              dossier.filterSelectMultiAttributes({
                filterInfo: {
                  key: 'W395' // Replace with the key of the filter that is being edited.
                },
                selections: [
                  {
                    value: 'hCoffee;68BC129B11EAC2895CE50080EFD50315' // Replace with value of selection.
                  },
                  {
                    value: 'hComputers;68BC129B11EAC2895CE50080EFD50315' // Replace with value of selection.
                  }
                ],
                holdSubmit: false
              });
              /* Select Multiple Attributes for the Filter End */`,
          },
          {
            displayName: 'Set Date Range for the Filter',
            tooltip: 'Select the from and to date range for the date range filter with "key".',
            link: documentation.FILTERS.APPLY_FILTERS,
            location: codeLocation.METHOD,
            code: `/* Set Date Range for the Filter Start */
              dossier.filterSetDateRange({
                filterInfo: {
                  key: 'W151'  // Replace with the key of the filter that is being edited.
                },
                date: {
                  from: '12/05/2016',  // Replace with the date you want to filter from.
                  to: '12/05/2016'  // Replace with the date you want to filter to.
                },
                holdSubmit: false
              });
              /* Set Date Range for the Filter End */`,
          },
          {
            displayName: 'Apply Metric Qualify by Rank Filter',
            tooltip: 'Apply metric qualify by rank filter.',
            link: documentation.FILTERS.APPLY_FILTERS,
            location: codeLocation.METHOD,
            code: `/* Apply Metric Qualify by Rank Filter Start */
              // This code snippet needs to be placed within on Page Loaded Event handler to work properly.
              dossier.filterSetMetricQualByRank({
                filterInfo: {
                  key: 'W161', // Replace with the key of the filter that is being edited.
                },
                exp: {
                  qualType: 'highest percent', // Replace with 'qualType' you want to use.
                  value: 10, // Replace with 'value' you want to use.
                },
                holdSubmit: false,
              });
              /* Apply Metric Qualify by Rank Filter End */`,
          },
          {
            displayName: 'Apply Metric Qualify by Value Filter',
            tooltip: 'Apply a metric qualify by value filter.',
            link: documentation.FILTERS.APPLY_FILTERS,
            location: codeLocation.METHOD,
            code: `/* Apply a Metric Qualify by Value Filter Start */
              // This code snippet needs to be placed within on Page Loaded Event handler to work properly.
              dossier.filterSetMetricQualByValue({
                filterInfo: {
                  key: 'W159',  // Replace with the key of the filter that is being edited.
                },
                exp: {
                  operator: 'between',
                  firstValue: 500000,
                  lastValue: 600000,
                },
                holdSubmit: false
              })
              /* Apply a Metric Qualify by Value Filter End */`,
          },
          {
            displayName: 'Clear All Filters',
            tooltip: 'Clear All Filters.',
            link: documentation.FILTERS.APPLY_FILTERS,
            location: codeLocation.METHOD,
            code: `/* Clear All Filters Start */
              dossier.filterClearAll();
              /* Clear All Filters End */`,
          },
          {
            displayName: 'Clear a Filter',
            tooltip: 'Clear filter with "key"',
            link: documentation.FILTERS.APPLY_FILTERS,
            location: codeLocation.METHOD,
            code: `/* Clear a Filter Start */
              dossier.filterClear({
                filterInfo: {
                  key: 'W161',  // Replace with the key of the filter that is being edited.
                },
                holdSubmit: false
              })
              /* Clear a Filter End */`,
          },
          {
            displayName: 'Apply All Cached Filters',
            tooltip: 'Applies all changes cached by "holdSubmit"',
            link: documentation.FILTERS.APPLY_FILTERS,
            location: codeLocation.METHOD,
            code: `/* Apply All Cached Filters Start */
              dossier.filterApplyAll()
              /* Apply All Cached Filters End */`,
          },
        ],
      },
      {
        groupName: EmbeddingType.Visualization,
        operationList: [
          {
            displayName: 'Get Current Page Visualizations',
            tooltip: 'Get the visualizations on the current page',
            link: documentation.VISUALIZATION.GENERAL,
            location: codeLocation.METHOD,
            code: `/* Get Current Page Visualizations Start */
            dossier.getCurrentPageVisualizationList().then((list) => {
              console.log('Current Page Visualization List:', list)
            }).catch((error) => {
              console.error(error)
            })
            /* Get Current Page Visualizations End */`,
          },
          {
            displayName: 'Change Visualization Size',
            tooltip: 'Change the visualization size on the selected visualization',
            link: documentation.VISUALIZATION.GENERAL,
            location: codeLocation.METHOD,
            code: `/* Change Visualization Size Start */
            dossier.changeVisualizationSize({
              visualizationKey:'W62', // Replace with visualization key in your dossier
              size: 'maximized',
              resizeButtonVisible: true
            }).then((visualization) => {
              console.log('The following visualization is maximized: ',visualization)
            }).catch((error) => {
              console.error(error)
            })
            /* Change Visualization Size End */`,
          },
          {
            displayName: 'Embed Single Visualization',
            tooltip: 'Configure embedding only a single visualization instead of entire dossier',
            link: documentation.VISUALIZATION.GENERAL,
            location: codeLocation.PROPERTY,
            code: `/* Embed Single Visualization Start */
              config.visualizationAppearances = [{
                visualizationKey:'W63', // Replace with visualization key in your dossier
                size:'maximized',
                resizeButtonVisible: false
              }]
            /* Embed Single Visualization End */`,
          },
          {
            displayName: 'Get Available Elements From Visualization',
            tooltip: 'Get the available elements from the selected visualization',
            link: documentation.VISUALIZATION.SELECT_ATTRIBUTE_ELEMENTS,
            location: codeLocation.METHOD,
            code: `/* Get Available Elements From Visualization Start */
            dossier
              .getAvailableElements('W64')
              .then((listOfElements) => console.log('The available elements are: ', listOfElements))
              .catch((error) => console.error(error)); // Replace 'W64' with your visualization key
            /* Get Available Elements From Visualization End */`,
          },
          {
            displayName: 'Select Visualization Element',
            tooltip: 'Select the selected attribute element of visualization.',
            link: documentation.VISUALIZATION.SELECT_ATTRIBUTE_ELEMENTS,
            location: codeLocation.METHOD,
            code: `/* Select Visualization Attribute Element Start */
            dossier.selectVizElement({
              vizKey: 'W64', // Replace with visualization key in your dossier
              action: 'replace', // Not required. Available values: replace, add, remove. Default: replace.
              selection: {
                attributeElements: [
                  // To get possible available elements use the dossier.getAvailableElements(visKey) api
                  {
                    attribute: {
                      id: '8D679D3611D3E4981000E787EC6DE8A4', // Replace with the attribute id of your selection.
                      name: 'Category' // Not required. Replace with the name of your attribute.
                    },
                    elements: [
                      {
                        id: 'h6;8D679D3611D3E4981000E787EC6DE8A4', // Replace with element id of your selection.
                        name: 'Spring 2012' // Not required. Replace with the name of your element.
                      }
                    ]
                  }
                ]
              }
            }).then((e) => console.log(e)).catch((error) => console.error(error));
            /* Select Visualization Attribute Element End */`,
          },
        ],
      },
      {
        groupName: 'Authoring',
        operationList: [
          {
            displayName: 'Enable Authoring Mode Configuration',
            tooltip: 'Sets up the necessary parameters in config for dashboard authoring',
            link: documentation.AUTHORING.GENERAL,
            location: codeLocation.PROPERTY,
            code: `/* Enable Authoring Mode Configuration Start */
            // The following config properties must be removed to allow dashboard authoring
            delete config['instance'];
            delete config['filters'];
            delete config['visualizationAppearances'];
            delete config['visualizationSelectedElements'];

            // Set to authoring mode
            config.dossierRenderingMode = 'authoring'; // Can be 'authoring' or 'consumption'
            config.navigationBar.edit = true; // Show the edit icon in navigation bar
            /* Enable Authoring Mode Configuration End */`,
          },
          {
            displayName: 'Customize Authoring Mode Properties',
            tooltip:
              'Show dashboard authoring mode configurations. Note: Enable Authoring Mode Configuration before this.',
            link: documentation.AUTHORING.GENERAL,
            location: codeLocation.PROPERTY,
            code: `/* Customize Authoring Mode Properties Start */
            config.authoring = {
              menubar: {
                library: {
                  visible: true, // Show library icon
                },
              },
              toolbar: {
                // For full list of options see documentation
                addData: { visible: false }, // Hide add data
              },
              panelVisibility: {
                contents: true,
                datasets: false,
                editor: false,
                filter: false,
                format: false,
                layers: false,
              }
            }
            /* Customize Authoring Mode Properties End */`,
          },
          {
            displayName: 'Switch to Authoring Mode',
            tooltip: 'Switches dashboard from consumption to authoring mode',
            link: documentation.AUTHORING.GENERAL,
            location: codeLocation.METHOD,
            code: `/* Switch to Authoring Mode Start */
            dossier.switchToMode('authoring').then((e)=>console.log(e)).catch((error) => console.error(error));
            /* Switch to Authoring Mode End */`,
          },
          {
            displayName: 'Create a New Dashboard',
            tooltip: 'Sets up the necessary parameters in config for creating a new dossier',
            link: documentation.AUTHORING.GENERAL,
            location: codeLocation.PROPERTY,
            code: `/* Create a New Dashboard Start */
            // The following config properties must be removed to allow dashboard authoring for a new dossier
            delete config['instance'];
            delete config['objectID'];
            delete config['url'];
            delete config['filters'];
            delete config['visualizationAppearances'];
            delete config['visualizationSelectedElements'];

            // Need serverURL and applicationID(projectID) for new dossier
            const urlRegExp = new RegExp(
              '(https?://[-a-zA-Z0-9@:%_.~#=+/]+/[-a-zA-Z0-9@:%_.~#=+]+)/app/([A-Z0-9]+)/([A-Z0-9]+)'
            );
            const urlMatched = url.match(urlRegExp);
            const serverUrl = urlMatched?.[1] || '';
            const projectId = urlMatched?.[2] || '';

            config.serverURL = serverUrl; // Can directly set and remove regex above if needed.
            config.applicationID = projectId; // Can directly set and remove regex above if needed.
            config.newDossier = true;
            // Set to authoring mode
            config.dossierRenderingMode = 'authoring'; // Can be 'authoring' or 'consumption'
            config.navigationBar.edit = true; // Show the edit icon in navigation bar
            /* Create a New Dashboard End */`,
          },
        ],
      },
    ],
  },
  {
    embeddingType: EmbeddingType.Library,
    operationGroups: [
      {
        groupName: 'Authentication',
        operationList: [
          {
            displayName: 'SAML Authentication',
            tooltip: 'Authenticate using SAML',
            link: documentation.AUTHENTICATION.SAML,
            location: codeLocation.PROPERTY,
            code: `/* SAML Authentication Start */
             config.customAuthenticationType = microstrategy.dossier.CustomAuthenticationType.AUTH_TOKEN;
             config.enableCustomAuthentication = true;
             config.getLoginToken = async () => {
              try {
                return await microstrategy.auth.samlLogin(
                  serverUrl
                );
              } catch (e) {
                console.error(e.message);
                if (
                  e.message ===
                  "Failed to open a new tab for login or the new tab handler cannot be got. Please contact your administrator."
                ) {
                  alert(
                    "Please enable popups to be directed to the login site. Refresh the page once popups have been enabled."
                  );
                }
              }
            }
            /* SAML Authentication End */`,
          },
          {
            displayName: 'OIDC Authentication',
            tooltip: 'Authenticate using OIDC',
            link: documentation.AUTHENTICATION.SAML,
            location: codeLocation.PROPERTY,
            code: `/* OIDC Authentication Start */
             config.customAuthenticationType = microstrategy.dossier.CustomAuthenticationType.AUTH_TOKEN;
             config.enableCustomAuthentication = true;
             config.getLoginToken = async () => {
              try {
                return await microstrategy.auth.oidcLogin(
                  serverUrl
                );
              } catch (e) {
                console.error(e.message);
                if (
                  e.message ===
                  "Failed to open a new tab for login or the new tab handler cannot be got. Please contact your administrator."
                ) {
                  alert(
                    "Please enable popups to be directed to the login site. Refresh the page once popups have been enabled."
                  );
                }
              }
            }
            /* OIDC Authentication End */`,
          },
          {
            displayName: 'Guest Authentication',
            tooltip: 'Authenticate as a guest user',
            link: documentation.AUTHENTICATION.GUEST,
            location: codeLocation.PROPERTY,
            code: `/* Guest Authentication Start */
            config.customAuthenticationType = microstrategy.dossier.CustomAuthenticationType.AUTH_TOKEN;
            config.enableCustomAuthentication = true;
            config.getLoginToken = async () => {
              options = {
                method: "POST",
                credentials: "include", // Including cookie
                mode: "cors", // Setting as cors mode for cross origin
                headers: { "content-type": "application/json" },
                body: JSON.stringify({
                  loginMode: 8, // 8 means guest login
                }),
              };
              return fetch(
                serverUrl + "/api/auth/login",
                options
              ).then((response) => {
                if (response.ok) {
                  console.log(
                    "A new guest login session has been created successfully, logging in"
                  );
                  return response.headers.get("x-mstr-authtoken");
                } else response.json().then((json) => console.log(json));
              })
              .catch((error) =>
                console.error("Failed Guest Login with error:", error)
              );
            };
            /* Guest Authentication End */`,
          },
          {
            displayName: 'Standard Authentication',
            tooltip: 'Authenticate using standard mode',
            link: documentation.AUTHENTICATION.STANDARD,
            location: codeLocation.PROPERTY,
            code: `/* Standard Authentication Start */
            config.customAuthenticationType = microstrategy.dossier.CustomAuthenticationType.AUTH_TOKEN;
            config.enableCustomAuthentication = true;
            config.getLoginToken = async () => {
              async function createAuthToken() {
                // Make a call to REST API to log the user in
                const options = {
                  method: "POST",
                  credentials: "include", // Including cookie
                  mode: "cors", // Setting as cors mode for cross origin
                  headers: { "content-type": "application/json" },
                  body: JSON.stringify({
                    loginMode: 1, // 1 means Standard login
                    username: "userNamePlaceHolder", // use guest / no password to test
                    password: "passwordPlaceHolder",
                  }),
                };
    
                try {
                  const response = await fetch(
                    serverUrl + "/api/auth/login",
                    options
                  );
    
                  if (response.ok) {
                    console.log(
                      "A new standard login session has been created successfully, logging in"
                    );
                    return response.headers.get("x-mstr-authtoken");
                  } else {
                    const json = await response.json();
                    console.log(json);
                  }
                } catch (error) {
                  console.error("Failed Standard Login with error:", error);
                }
              }
              return await createAuthToken();
            };
            /* Standard Authentication End */`,
          },
          {
            displayName: 'LDAP Authentication',
            tooltip: 'Authenticate using LDAP mode',
            link: documentation.AUTHENTICATION.STANDARD,
            location: codeLocation.PROPERTY,
            code: `/* LDAP Authentication Start */
            config.customAuthenticationType = microstrategy.dossier.CustomAuthenticationType.AUTH_TOKEN;
            config.enableCustomAuthentication = true;
            config.getLoginToken = async () => {
              async function createAuthToken() {
                // Make a call to REST API to log the user in
                const options = {
                  method: "POST",
                  credentials: "include", // Including cookie
                  mode: "cors", // Setting as cors mode for cross origin
                  headers: { "content-type": "application/json" },
                  body: JSON.stringify({
                    loginMode: 16, // 16 means LDAP login
                    username: "userNamePlaceHolder", // use guest / no password to test
                    password: "passwordPlaceHolder",
                  }),
                };
    
                try {
                  const response = await fetch(
                    serverUrl + "/api/auth/login",
                    options
                  );
    
                  if (response.ok) {
                    console.log(
                      "A new LDAP login session has been created successfully, logging in"
                    );
                    return response.headers.get("x-mstr-authtoken");
                  } else {
                    const json = await response.json();
                    console.log(json);
                  }
                } catch (error) {
                  console.error("Failed LDAP Login with error:", error);
                }
              }
              return await createAuthToken();
            };
            /* LDAP Authentication End */`,
          },
          {
            displayName: 'Identity Token Authentication',
            tooltip: 'Authenticate using identity token',
            link: documentation.AUTHENTICATION.IDENTITY,
            location: codeLocation.PROPERTY,
            code: `/* Identity Authentication Start */
            config.customAuthenticationType =
            microstrategy.dossier.CustomAuthenticationType.IDENTITY_TOKEN;
            config.enableCustomAuthentication = true;
            config.getLoginToken = async function login() {
            async function createAuthToken() {
              // Make a call to REST API to log the user in
              const options = {
                method: "POST",
                credentials: "include", // Including cookie
                mode: "cors", // Setting as cors mode for cross origin
                headers: { "content-type": "application/json" },
                body: JSON.stringify({
                  loginMode: 1, // 1 means Standard login
                  username: "userNamePlaceHolder", // use guest / no password to test
                  password: "passwordPlaceHolder",
                }),
              };
  
              try {
                const response = await fetch(
                  serverUrl + "/api/auth/login",
                  options
                );
  
                if (response.ok) {
                  console.log(
                    "A new standard login session has been created successfully, logging in"
                  );
                  return response.headers.get("x-mstr-authtoken");
                } else {
                  const json = await response.json();
                  console.log(json);
                }
              } catch (error) {
                console.error("Failed Standard Login with error:", error);
              }
            }
  
            async function getIdentityToken(authToken) {
              const identityOptions = {
                method: "GET",
                credentials: "include", // Including cookie
                mode: "cors", // Setting as cors mode for cross origin
                headers: {
                  "Content-Type": "application/json",
                  "X-MSTR-AuthToken": authToken,
                },
              };
  
              try {
                const response = await fetch(
                  serverUrl + "/api/auth/identityToken",
                  identityOptions
                );
  
                if (response.ok) {
                  return response.headers.get("x-mstr-identitytoken");
                } else {
                  const json = await response.json();
                  console.log(json);
                }
              } catch (error) {
                console.error("Failed Identity Login with error:", error);
              }
            }
  
            return await getIdentityToken(await createAuthToken());
          };
          /* Identity Authentication End */`,
          },
          // {
          //   displayName: 'OAuth2 Authentication',
          //   tooltip: 'Authenticate using OAuth2',
          //   link: documentation.AUTHENTICATION.OAuth2,
          //   location: codeLocation.PROPERTY,
          //   code: `/* OAuth Authentication Start */
          //   config.customAuthenticationType =
          //     microstrategy.dossier.CustomAuthenticationType.AUTH_TOKEN;
          //   config.enableCustomAuthentication = true;
          //   config.getLoginToken = async () => {
          //     try {
          //       let data = await microstrategy.auth.oauthLogin(serverUrl, {
          //         clientId: 'your client id',
          //         clientSecret: 'your client secret',
          //         requireRefreshToken: true
          //       });
          //       return data.accessToken
          //     } catch (e) {
          //       console.error(e.message);
          //       if (
          //         e.message ===
          //         "Failed to open a new tab for login or the new tab handler cannot be got. Please contact your administrator."
          //       ) {
          //         alert(
          //           "Please enable popups to be directed to the login site. Refresh the page once popups have been enabled."
          //         );
          //       }
          //     }
          //   };
          //   /* OAuth Authentication End */`,
          // },
        ],
      },
      {
        groupName: 'Library Page',
        operationList: [
          {
            displayName: 'Embed Library Page',
            tooltip: 'Embeds the library home page',
            link: documentation.LIBRARY_PAGE.GENERAL,
            location: codeLocation.METHOD,
            code: `/* Set Embed Library Page Start */
            config = {
              serverUrl: 'https://demo.microstrategy.com/MicroStrategyLibrary', // Replace with your Library server url
              placeholder: document.getElementById('${previewPanel.EMBEDDING_CONTAINER_ID}'),
            }
            try {
              embeddingContext = await microstrategy.embeddingContexts.embedLibraryPage(config);
            } catch(error){
              // Your custom error handling logic here
              console.error(error)
            }
            /* Set Embed Library Page End */`,
          },
          {
            displayName: 'Library Page Layout',
            tooltip:
              'Show Library home page layout configurations and Specify the page on the side bar entries that you want to embed.',
            link: documentation.LIBRARY_PAGE.CUSTOM_UI,
            location: codeLocation.PROPERTY,
            code: `/* Library Page Layout Start */
            // Specify the custom UI settings on the embedded page.
            config.customUi = {
              ...config.customUi,
              library: {
                navigationBar: {
                  enabled: true, // Show or hide the navigation bar.
                  sortAndFilter: true, // Show or hide the library filter icon and the search bar.
                  title: true, // Show or hide the title.
                  searchBar: true, // Show or hide the search bar.
                  createNew: {
                    enabled: true, // Show or hide the "Create New" button.
                  },
                  notifications: true, // Show or hide the notification button.
                  multiSelect: {
                    enabled: true, // Show or hide the multi-select button.
                  },
                  account: {
                    enabled: true, // Show or hide the account button.
                  },
                },
                sidebar: {
                  enabled: true, // Show or hide the "show sidebar" icon.
                  show: false, // Show or hide the sidebar. sidebar.enabled must be "true" and custom application must have this enabled to show.
                }
              }
            }

            // Specify the page on the side bar entries that you want to embed.
            config.currentPage = {
              key: 'defaultGroups', // Can be ['all', 'myContent', 'favorites', 'recents', 'insights', 'subscriptions', 'defaultGroups', 'myGroups'].
              // The targetGroup property is needed only when the key is 'defaultGroups' or 'myGroups'. Either id or name is required in this case.
              targetGroup: {
                id: 'B5AEDC730A4D67F01AEAA19E87BB27E5',
                name: 'Solutions'
              }
            }
            /* Library Page Layout End */`,
          },
          {
            displayName: 'Dashboard Consumption Layout',
            tooltip: 'Show dashboard consumption mode layout configurations',
            link: documentation.LIBRARY_PAGE.CUSTOM_UI,
            location: codeLocation.PROPERTY,
            code: `/* Dashboard Consumption Layout Start */
            // Specify the custom UI settings on the embedded page.
            config.customUi = {
              ...config.customUi,
              dossierConsumption: {
                navigationBar: {
                  enabled: true, // Show or hide the navigation bar.
                  gotoLibrary: false, // Show or hide the "gotoLibrary" icon.
                  title: false, // Show or hide the dashboard title.
                  toc: true, // Show or hide the table of contents icon.
                  reset: true, // Show or hide the reset icon.
                  reprompt: false, // Show or hide the reprompt icon.
                  share: false, // Show or hide the share icon.
                  comment: true, // Show or hide the comment icon.
                  notification: false, // Show or hide the notification icon.
                  filter: true, // Show or hide the filter icon.
                  options: true, // Show or hide the options icon.
                  search: false, // Show or hide the search icon.
                  bookmark: true, // Show or hide the bookmark icon.
                  edit: false, // Show or hide the edit icon.
                },
              },
            }
            /* Dashboard Consumption Layout End */`,
          },
          {
            displayName: 'Dashboard Authoring Layout',
            tooltip: 'Show dashboard authoring mode layout configurations',
            link: documentation.LIBRARY_PAGE.CUSTOM_UI,
            location: codeLocation.PROPERTY,
            code: `/* Dashboard Authoring Layout Start */
            // Specify the custom UI settings on the embedded page.
            config.customUi = {
              ...config.customUi,
              dossierAuthoring: {
                // The toolbar property handles the visibility of the toolbar icons on dashboard authoring page
                toolbar: {
                  tableOfContents: {
                    visible: false, // Show or hide table of contents button
                  },
                  undo: {
                    visible: false, // Show or hide undo button
                  },
                  redo: {
                    visible: false, // Show or hide redo button
                  },
                  refresh: {
                    visible: false, // Show or hide refresh button
                  },
                  pauseDataRetrieval: {
                    visible: false, // Show or hide "pauseDataRetrieval" button
                  },
                  dividerLeft: {
                    visible: false, // Show or hide left divider
                  },
                  addData: {
                    visible: false, // Show or hide "Add Data" button
                  },
                  addChapter: {
                    visible: false, // Show or hide "Add Chapter" button
                  },
                  addPage: {
                    visible: false, // Show or hide "Add Page" button
                  },
                  insertVisualization: {
                    visible: false, // Show or hide "Visualization" button
                  },
                  insertFilter: {
                    visible: false, // Show or hide "Filter" button
                  },
                  insertText: {
                    visible: false, // Show or hide "Text" button
                  },
                  insertImage: {
                    visible: false, // Show or hide "Image" button
                  },
                  insertHtml: {
                    visible: false, // Show or hide "Html" button
                  },
                  insertShape: {
                    visible: false, // Show or hide "Shape" button
                  },
                  insertPanelStack: {
                    visible: false, // Show or hide "Panel Stack" button
                  },
                  insertInfoWindow: {
                    visible: false, // Show or hide "Information Window" button
                  },
                  save: {
                    visible: false, // Show or hide save button
                  },
                  dividerRight: {
                    visible: false, // Show or hide right divider
                  },
                  more: {
                    visible: false, // Show or hide "More" button
                  },
                  freeformLayout: {
                    visible: false, // Show or hide "Freeform Layout" button
                  },
                  nlp: {
                    visible: false, // Show or hide nlp button
                  },
                  responsiveViewEditor: {
                    visible: false, // Show or hide "Responsive View Editor" button
                  },
                  responsivePreview: {
                    visible: false, // Show or hide "Responsive Preview" button
                  },
                },
                menubar: {
                  library: {
                    visible: false, // Show or hide Library home icon
                  },
                },
              },
            }
            /* Dashboard Authoring Layout End */`,
          },
          {
            displayName: 'Get All My Groups',
            tooltip: 'Retrieves the all the group items under "My Groups"',
            link: documentation.LIBRARY_PAGE.APIS,
            location: codeLocation.METHOD,
            code: `/* Get All My Groups Start */
            embeddingContext.libraryPage.getAllMyGroups().then((groups) => {
              console.log('The groups are: ', groups)
            }).catch((error) => {
              console.error(error)
            })
            /* Get All My Groups End */`,
          },
          {
            displayName: 'Get All Default Groups',
            tooltip: 'Retrieves the all the group items under "Default Groups"',
            link: documentation.LIBRARY_PAGE.APIS,
            location: codeLocation.METHOD,
            code: `/* Get All Default Groups Start */
            embeddingContext.libraryPage.getAllDefaultGroups().then((groups) => {
              console.log('The groups are: ', groups)
            }).catch((error) => {
              console.error(error)
            })
            /* Get All Default Groups End */`,
          },
          {
            displayName: 'Show Navigation Bar',
            tooltip: 'Enables or disables the navigation bar dynamically',
            link: documentation.LIBRARY_PAGE.APIS,
            location: codeLocation.METHOD,
            code: `/* Show Navigation Bar Start */
            embeddingContext.libraryPage.setNavigationBarEnabled(true).then(() => {
              console.log('Set Library Navigation Bar')
            }).catch((error) => {
              console.error(error)
            });
            /* Show Navigation Bar End */`,
          },
          {
            displayName: 'Show Sidebar',
            tooltip: 'Show or hides the sidebar dynamically',
            link: documentation.LIBRARY_PAGE.APIS,
            location: codeLocation.METHOD,
            code: `/* Show Sidebar Start */
            embeddingContext.libraryPage.setSidebarVisibility(true).then(() => {
              console.log('Set Library Sidebar')
            }).catch((error) => {
              console.error(error)
            });
            /* Show Sidebar End */`,
          },
          {
            displayName: 'Project Filter',
            tooltip: 'Filter library content by project ID',
            link: documentation.LIBRARY_PAGE.PROPERTIES,
            location: codeLocation.PROPERTY,
            code: `/* Project Filter Start */
            config.settings = {
              filter: {
                projects : ["B7CA92F04B9FAE8D941C3E9B7E0CD754"]
              }
            }
            /* Project Filter End */`,
          },
        ],
      },
      {
        groupName: 'Error Handler',
        operationList: [
          {
            displayName: 'Add Custom Error Handler During Library Creation',
            tooltip: 'The error handler used during library creation',
            link: documentation.ERROR.DURING_DOSSIER_CREATION,
            location: codeLocation.PROPERTY,
            code: `/* Add Custom Error Handler During Library Creation Start*/
              config.errorHandler = function customErrorHandler(error) {
                /* Add any functionality for handling event here */
                console.log('Catch error: ' + error.message);
              }
              config.disableCustomErrorHandlerOnCreate = false
              /* Add Custom Error Handler During Library Creation End*/`,
          },
          {
            displayName: 'Add Custom Session Error Handler During Library Creation',
            tooltip: 'The session error handler used during library creation',
            link: documentation.ERROR.DURING_DOSSIER_CREATION,
            location: codeLocation.PROPERTY,
            code: `/* Add Custom Session Error Handler During Library Creation Start*/
              config.sessionErrorHandler = function customSessionErrorHandler(error) {
                /* Add any functionality for handling event here */
                console.log('Catch session error: ' + error.message);
              }
              /* Add Custom Session Error Handler During Library Creation End*/`,
          },
          {
            displayName: 'Add Custom Error Handler After Library Creation',
            tooltip: 'You can also provide error handling after the library is created',
            link: documentation.ERROR.AFTER_DOSSIER_CREATION,
            location: codeLocation.METHOD,
            code: `/* Add Custom Error Handler After Library Creation Start */
              // addCustomErrorHandler(callback:function, showPopUp:boolean)
              embeddingContext.addCustomErrorHandler(function customErrorHandler(error) {
                /* Add any functionality for handling event here */
                console.log('Catch error: ' + error.message);
              }, false);
              /* Add Custom Error Handler After Library Creation End */`,
          },
          {
            displayName: 'Add Custom Session Error Handler After Library Creation',
            tooltip: 'You can also provide session error handling after the library is created',
            link: documentation.ERROR.AFTER_DOSSIER_CREATION,
            location: codeLocation.METHOD,
            code: `/* Add Custom Session Error Handler After Library Creation Start */
              // addSessionErrorHandler(callback:function)
              embeddingContext.addSessionErrorHandler(function customSessionErrorHandler(error) {
                /* Add any functionality for handling event here */
                console.log('Catch error: ' + error.message);
              }, false);
              /* Add Custom Session Error Handler After Library Creation End */`,
          },
        ],
      },
      navigateGroup,
    ],
  },
  {
    embeddingType: EmbeddingType.Bot,
    operationGroups: [
      {
        groupName: 'Authentication',
        operationList: [
          {
            displayName: 'SAML Authentication',
            tooltip: 'Authenticate using SAML',
            link: documentation.AUTHENTICATION.SAML,
            location: codeLocation.PROPERTY,
            code: `/* SAML Authentication Start */
             config.customAuthenticationType = microstrategy.dossier.CustomAuthenticationType.AUTH_TOKEN;
             config.enableCustomAuthentication = true;
             config.getLoginToken = async () => {
              try {
                return await microstrategy.auth.samlLogin(
                  serverUrl
                );
              } catch (e) {
                console.error(e.message);
                if (
                  e.message ===
                  "Failed to open a new tab for login or the new tab handler cannot be got. Please contact your administrator."
                ) {
                  alert(
                    "Please enable popups to be directed to the login site. Refresh the page once popups have been enabled."
                  );
                }
              }
            }
            /* SAML Authentication End */`,
          },
          {
            displayName: 'OIDC Authentication',
            tooltip: 'Authenticate using OIDC',
            link: documentation.AUTHENTICATION.SAML,
            location: codeLocation.PROPERTY,
            code: `/* OIDC Authentication Start */
             config.customAuthenticationType = microstrategy.dossier.CustomAuthenticationType.AUTH_TOKEN;
             config.enableCustomAuthentication = true;
             config.getLoginToken = async () => {
              try {
                return await microstrategy.auth.oidcLogin(
                  serverUrl
                );
              } catch (e) {
                console.error(e.message);
                if (
                  e.message ===
                  "Failed to open a new tab for login or the new tab handler cannot be got. Please contact your administrator."
                ) {
                  alert(
                    "Please enable popups to be directed to the login site. Refresh the page once popups have been enabled."
                  );
                }
              }
            }
            /* OIDC Authentication End */`,
          },
          {
            displayName: 'Guest Authentication',
            tooltip: 'Authenticate as a guest user',
            link: documentation.AUTHENTICATION.GUEST,
            location: codeLocation.PROPERTY,
            code: `/* Guest Authentication Start */
            config.customAuthenticationType = microstrategy.dossier.CustomAuthenticationType.AUTH_TOKEN;
            config.enableCustomAuthentication = true;
            config.getLoginToken = async () => {
              options = {
                method: "POST",
                credentials: "include", // Including cookie
                mode: "cors", // Setting as cors mode for cross origin
                headers: { "content-type": "application/json" },
                body: JSON.stringify({
                  loginMode: 8, // 8 means guest login
                }),
              };
              return fetch(
                serverUrl + "/api/auth/login",
                options
              ).then((response) => {
                if (response.ok) {
                  console.log(
                    "A new guest login session has been created successfully, logging in"
                  );
                  return response.headers.get("x-mstr-authtoken");
                } else response.json().then((json) => console.log(json));
              })
              .catch((error) =>
                console.error("Failed Guest Login with error:", error)
              );
            };
            /* Guest Authentication End */`,
          },
          {
            displayName: 'Standard Authentication',
            tooltip: 'Authenticate using standard mode',
            link: documentation.AUTHENTICATION.STANDARD,
            location: codeLocation.PROPERTY,
            code: `/* Standard Authentication Start */
            config.customAuthenticationType = microstrategy.dossier.CustomAuthenticationType.AUTH_TOKEN;
            config.enableCustomAuthentication = true;
            config.getLoginToken = async () => {
              async function createAuthToken() {
                // Make a call to REST API to log the user in
                const options = {
                  method: "POST",
                  credentials: "include", // Including cookie
                  mode: "cors", // Setting as cors mode for cross origin
                  headers: { "content-type": "application/json" },
                  body: JSON.stringify({
                    loginMode: 1, // 1 means Standard login
                    username: "userNamePlaceHolder", // use guest / no password to test
                    password: "passwordPlaceHolder",
                  }),
                };
    
                try {
                  const response = await fetch(
                    serverUrl + "/api/auth/login",
                    options
                  );
    
                  if (response.ok) {
                    console.log(
                      "A new standard login session has been created successfully, logging in"
                    );
                    return response.headers.get("x-mstr-authtoken");
                  } else {
                    const json = await response.json();
                    console.log(json);
                  }
                } catch (error) {
                  console.error("Failed Standard Login with error:", error);
                }
              }
              return await createAuthToken();
            };
            /* Standard Authentication End */`,
          },
          {
            displayName: 'LDAP Authentication',
            tooltip: 'Authenticate using LDAP mode',
            link: documentation.AUTHENTICATION.STANDARD,
            location: codeLocation.PROPERTY,
            code: `/* LDAP Authentication Start */
            config.customAuthenticationType = microstrategy.dossier.CustomAuthenticationType.AUTH_TOKEN;
            config.enableCustomAuthentication = true;
            config.getLoginToken = async () => {
              async function createAuthToken() {
                // Make a call to REST API to log the user in
                const options = {
                  method: "POST",
                  credentials: "include", // Including cookie
                  mode: "cors", // Setting as cors mode for cross origin
                  headers: { "content-type": "application/json" },
                  body: JSON.stringify({
                    loginMode: 16, // 16 means LDAP login
                    username: "userNamePlaceHolder", // use guest / no password to test
                    password: "passwordPlaceHolder",
                  }),
                };
    
                try {
                  const response = await fetch(
                    serverUrl + "/api/auth/login",
                    options
                  );
    
                  if (response.ok) {
                    console.log(
                      "A new LDAP login session has been created successfully, logging in"
                    );
                    return response.headers.get("x-mstr-authtoken");
                  } else {
                    const json = await response.json();
                    console.log(json);
                  }
                } catch (error) {
                  console.error("Failed LDAP Login with error:", error);
                }
              }
              return await createAuthToken();
            };
            /* LDAP Authentication End */`,
          },
          {
            displayName: 'Identity Token Authentication',
            tooltip: 'Authenticate using identity token',
            link: documentation.AUTHENTICATION.IDENTITY,
            location: codeLocation.PROPERTY,
            code: `/* Identity Authentication Start */
            config.customAuthenticationType =
            microstrategy.dossier.CustomAuthenticationType.IDENTITY_TOKEN;
            config.enableCustomAuthentication = true;
            config.getLoginToken = async function login() {
            async function createAuthToken() {
              // Make a call to REST API to log the user in
              const options = {
                method: "POST",
                credentials: "include", // Including cookie
                mode: "cors", // Setting as cors mode for cross origin
                headers: { "content-type": "application/json" },
                body: JSON.stringify({
                  loginMode: 1, // 1 means Standard login
                  username: "userNamePlaceHolder", // use guest / no password to test
                  password: "passwordPlaceHolder",
                }),
              };
  
              try {
                const response = await fetch(
                  serverUrl + "/api/auth/login",
                  options
                );
  
                if (response.ok) {
                  console.log(
                    "A new standard login session has been created successfully, logging in"
                  );
                  return response.headers.get("x-mstr-authtoken");
                } else {
                  const json = await response.json();
                  console.log(json);
                }
              } catch (error) {
                console.error("Failed Standard Login with error:", error);
              }
            }
  
            async function getIdentityToken(authToken) {
              const identityOptions = {
                method: "GET",
                credentials: "include", // Including cookie
                mode: "cors", // Setting as cors mode for cross origin
                headers: {
                  "Content-Type": "application/json",
                  "X-MSTR-AuthToken": authToken,
                },
              };
  
              try {
                const response = await fetch(
                  serverUrl + "/api/auth/identityToken",
                  identityOptions
                );
  
                if (response.ok) {
                  return response.headers.get("x-mstr-identitytoken");
                } else {
                  const json = await response.json();
                  console.log(json);
                }
              } catch (error) {
                console.error("Failed Identity Login with error:", error);
              }
            }
  
            return await getIdentityToken(await createAuthToken());
          };
          /* Identity Authentication End */`,
          },
          // {
          //   displayName: 'OAuth2 Authentication',
          //   tooltip: 'Authenticate using OAuth2',
          //   link: documentation.AUTHENTICATION.OAuth2,
          //   location: codeLocation.PROPERTY,
          //   code: `/* OAuth Authentication Start */
          //   config.customAuthenticationType =
          //     microstrategy.dossier.CustomAuthenticationType.AUTH_TOKEN;
          //   config.enableCustomAuthentication = true;
          //   config.getLoginToken = async () => {
          //     try {
          //       let data = await microstrategy.auth.oauthLogin(serverUrl, {
          //         clientId: 'your client id',
          //         clientSecret: 'your client secret',
          //         requireRefreshToken: true
          //       });
          //       return data.accessToken
          //     } catch (e) {
          //       console.error(e.message);
          //       if (
          //         e.message ===
          //         "Failed to open a new tab for login or the new tab handler cannot be got. Please contact your administrator."
          //       ) {
          //         alert(
          //           "Please enable popups to be directed to the login site. Refresh the page once popups have been enabled."
          //         );
          //       }
          //     }
          //   };
          //   /* OAuth Authentication End */`,
          // },
        ],
      },
      {
        groupName: 'Bot Page',
        operationList: [
          {
            displayName: 'Configure Navigation Bar',
            tooltip: 'Configure the navigation bar',
            link: documentation.BOT_PAGE.PROPERTIES,
            location: codeLocation.PROPERTY,
            code: `/* Configure Navigation Bar Start */
            config.customUi.botConsumption = {
              ...config.customUi.botConsumption,
              navigationBar: {
                enabled: true,
              },
            };
            /* Configure Navigation Bar End */`,
          },
          {
            displayName: 'Configure Snapshot',
            tooltip: 'Configure the snapshot',
            link: documentation.BOT_PAGE.PROPERTIES,
            location: codeLocation.PROPERTY,
            code: `/* Configure Snapshot Start */
            config.customUi.botConsumption = {
              ...config.customUi.botConsumption,
              snapshot: {
                enabled: false,
              },
            };
            /* Configure Snapshot End */`,
          },
          {
            displayName: 'Configure Add To Library Banner',
            tooltip: 'Configure Add To Library Banner',
            link: documentation.BOT_PAGE.PROPERTIES,
            location: codeLocation.PROPERTY,
            code: `/* Configure Add To Library Banner Start */
            config.customUi = {
              ...config.customUi,
              addToLibraryBanner: {
                enabled: true,
              },
            };
            /* Configure Add To Library Banner End */`,
          },
          {
            displayName: 'Configure Clipboard Write Privilege',
            tooltip: 'Configure Clipboard Write',
            link: documentation.BOT_PAGE.PROPERTIES,
            location: codeLocation.PROPERTY,
            code: `/* Set Allow Clipboard Write Start */
            config = {
              ...config,
              permissions: {
                allowClipboardWrite: true,
              },
            };
            /* Configure Clipboard Write Privilege End */`,
          },
        ],
      },
      {
        groupName: 'Error Handler',
        operationList: [
          {
            displayName: 'Add Custom Error Handler During Bot Creation',
            tooltip: 'The error handler used during bot creation',
            link: documentation.ERROR.DURING_DOSSIER_CREATION,
            location: codeLocation.PROPERTY,
            code: `/* Add Custom Error Handler During Bot Creation Start*/
              config.errorHandler = function customErrorHandler(error) {
                /* Add any functionality for handling event here */
                console.log('Catch error: ' + error.message);
              }
              config.disableCustomErrorHandlerOnCreate = false
              /* Add Custom Error Handler During Bot Creation End*/`,
          },
          {
            displayName: 'Add Custom Session Error Handler During Bot Creation',
            tooltip: 'The session error handler used during bot creation',
            link: documentation.ERROR.DURING_DOSSIER_CREATION,
            location: codeLocation.PROPERTY,
            code: `/* Add Custom Session Error Handler During Bot Creation Start*/
              config.sessionErrorHandler = function customSessionErrorHandler(error) {
                /* Add any functionality for handling event here */
                console.log('Catch session error: ' + error.message);
              }
              /* Add Custom Session Error Handler During Bot Creation End*/`,
          },
          {
            displayName: 'Add Custom Error Handler After Bot Creation',
            tooltip: 'You can also provide error handling after the bot is created',
            link: documentation.ERROR.AFTER_DOSSIER_CREATION,
            location: codeLocation.METHOD,
            code: `/* Add Custom Error Handler After Bot Creation Start */
              // addCustomErrorHandler(callback:function, showPopUp:boolean)
              embeddingContext.addCustomErrorHandler(function customErrorHandler(error) {
                /* Add any functionality for handling event here */
                console.log('Catch error: ' + error.message);
              }, false);
              /* Add Custom Error Handler After Bot Creation End */`,
          },
          {
            displayName: 'Add Custom Session Error Handler After Bot Creation',
            tooltip: 'You can also provide session error handling after the bot is created',
            link: documentation.ERROR.AFTER_DOSSIER_CREATION,
            location: codeLocation.METHOD,
            code: `/* Add Custom Session Error Handler After Bot Creation Start */
              // addSessionErrorHandler(callback:function)
              embeddingContext.addSessionErrorHandler(function customSessionErrorHandler(error) {
                /* Add any functionality for handling event here */
                console.log('Catch error: ' + error.message);
              }, false);
              /* Add Custom Session Error Handler After Bot Creation End */`,
          },
        ],
      },
      navigateGroup,
    ],
  },
  {
    embeddingType: EmbeddingType.Bot_Api,
    operationGroups: [
      {
        groupName: 'Authentication',
        operationList: nativeAuthentication,
      },
    ],
  },
  {
    embeddingType: EmbeddingType.Bot_Auto,
    operationGroups: [
      {
        groupName: 'Authentication',
        operationList: nativeAuthentication,
      },
    ],
  },
  {
    embeddingType: EmbeddingType.Bot_AutoImage,
    operationGroups: [
      {
        groupName: 'Authentication',
        operationList: nativeAuthentication,
      },
    ],
  },
  {
    embeddingType: EmbeddingType.NextGet_AI,
    operationGroups: [
      {
        groupName: 'Authentication',
        operationList: nativeAuthentication,
      },
    ],
  },
  {
    embeddingType: EmbeddingType.Visualization,
    operationGroups: [
      {
        groupName: 'Authentication',
        operationList: nativeAuthentication,
      },
      {
        groupName: 'Get Data Information',
        // Authentication
        operationList: [
          {
            displayName: 'Get Dashboard Definition',
            tooltip: 'get dashboard definition',
            link: documentation.NATIVE_VISUALIZATION.GET_INFO,
            location: codeLocation.METHOD,
            code: `// retrieve the definition of the dashboard.
            const dossierDef = await dossier.getDossierDefinition();
            console.log("Dashboard Definition:");
            console.log(dossierDefinition);`,
          },
          {
            displayName: 'Get Visualization Data',
            tooltip: 'get visualization data',
            link: documentation.NATIVE_VISUALIZATION.GET_INFO,
            location: codeLocation.METHOD,
            code: `// retrieve the data of a single visualization.
            const vizDef = await dossier.getVisualizationData({
                visualizationKey: "<string>", // visualization key, required
                //offset: 0, // data offset, optional
                //limit: 100, // data limit, optional
            });
            console.log("Visualization Data:");
            console.log(vizDef);`,
          },
          {
            displayName: 'Get Filter Element',
            tooltip: 'get the attribute elements of the filter or selector.',
            link: documentation.NATIVE_VISUALIZATION.GET_INFO,
            location: codeLocation.METHOD,
            code: `// retrieve the available attribute elements of the filters or selectors.
            const filterDef = await dossier.getFilterAvailableElements({
                filterKey: "<string>", // filter or selector key, required
                // searchPattern: "o", // pattern to match with the element list, optional
                // offset: 0, // optional
                // limit: 100, // optional
            });
            console.log("Filter Data:");
            console.log(filterDef);`,
          },
        ],
      },
      {
        groupName: 'Apply Filters',
        operationList: [
          {
            displayName: 'Apply Chapter Level Filter',
            tooltip: 'Apply chapter level filter',
            link: documentation.NATIVE_VISUALIZATION.APPLY_FILTER,
            location: codeLocation.METHOD,
            code: `// apply chapter level filter
            await dossier.applyFilter({
              key: "<string>", // chapter filter key, required
              currentSelection: {
                // selectionStatus: "<string>", // optional, values: ['unfiltered', 'included', 'excluded'], default: 'included'
                // allSelected: "<boolean>", // optional, default: false,
                elements: [
                  {
                    id: "<string>", // attribute element id, required
                    // name: "<string>", // attribute element name, optional
                  },
                ],
              },
            });`,
          },
          {
            displayName: 'Apply Page Level Filter',
            tooltip: 'Apply page level filter',
            link: documentation.NATIVE_VISUALIZATION.APPLY_FILTER,
            location: codeLocation.METHOD,
            code: `// apply page level filter
            await dossier.applyFilter({
              key: "<string>", // page selector key, required
              currentSelection: {
                // selectionStatus: "<string>", // optional, values: ['unfiltered', 'included', 'excluded'], default: 'included'
                // allSelected: "<boolean>", // optional, default: false,
                elements: [
                  {
                    id: "<string>", // attribute element id, required
                    // name: "<string>", // attribute element name, optional
                  },
                ],
              },
            });`,
          },
          {
            displayName: 'Filter Visualization Attribute',
            tooltip: 'Filter visualization attribute',
            link: documentation.NATIVE_VISUALIZATION.APPLY_FILTER,
            location: codeLocation.METHOD,
            code: `// use visualization as filter: attribute element selection
            await dossier.applyFilter({
              key: "<string>", // visualization key, required
              currentSelection: {
                // selectionStatus: "included", // optional, values: ['unfiltered', 'included', 'excluded'], default: 'included'
                type: "attribute_element_list", // required
                selections: [
                  {
                    attribute: {
                      id: "<string>", // attribute id, required
                      // name: "<string>", // attribute name, optional
                    },
                    elements: [
                      {
                        id: "<string>", // attribute element id, required
                        // name: "<string>", // attribute element name, optional
                      },
                    ],
                  },
                ],
              },
            });`,
          },
          {
            displayName: 'Filter Visualization Metric',
            tooltip: 'Filter visualization metric',
            link: documentation.NATIVE_VISUALIZATION.APPLY_FILTER,
            location: codeLocation.METHOD,
            code: `// use visualization as filter: metric element selection
            await dossier.applyFilter({
              key: "<string>", // visualization key, required
              currentSelection: {
                // selectionStatus: "included", // optional, values: ['unfiltered', 'included', 'excluded'], default: 'included'
                type: "metric_element_list", // required
                attributes: [
                  // should be the same list as all attributes in the visualization
                  {
                    id: "<string>", // attribute id, required
                    // name: "<string>", // attribute name, optional
                  },
                ],
                selections: [
                  [
                    // one metric element selection
                    {
                      id: "<string>", // attribute element id, required
                      // name: "<string>", // attribute element name, optional
                    },
                  ],
                ],
              },
            });`,
          },
        ],
      },
      {
        groupName: 'Event Handler',
        operationList: [
          {
            displayName: 'Register Event Handler',
            tooltip: 'Register event handler',
            link: documentation.NATIVE_VISUALIZATION.EVENT_HANDLING,
            location: codeLocation.METHOD,
            code: `// register event handler
          dossier.registerEventHandler(eventName, (event) => {
            // Your own event handling code
          });`,
          },
          {
            displayName: 'Register Error Handler',
            tooltip: 'Register error handler',
            link: documentation.NATIVE_VISUALIZATION.EVENT_HANDLING,
            location: codeLocation.METHOD,
            code: `// register error handler
          dossier.registerErrorHandler((error) => {
            // Your own error handling code
          });`,
          },
        ],
      },
    ],
  },
];

/* Operation Item Constant */
export const operationItemDataType = 'Operation Item';

/* Actions */
export const CodePanelActions = {
  UPDATE_CONTENT: 'UPDATE_CONTENT',
  ON_LOAD: 'ON_LOAD',
  SAVE_CODE: 'SAVE_CODE',
  ON_SELECTION: 'ON_SELECTION',
  INSERT_OPERATION_CODE: 'INSERT_OPERATION_CODE',
};

export const GoogleAnalyticsActions = {
  SEND_GA_EVENT: 'SEND_GA_EVENT',
  SET_USER_ID: 'SET_USER_ID',
};

export const OperationsMenuActions = {
  CHANGE_TYPE: 'CHANGE_TYPE',
  SAVE_CHANGE_TYPE: 'SAVE_CHANGE_TYPE',
  SAVE_CHANGE_SUB_TYPE: 'SAVE_CHANGE_SUB_TYPE',
};

export const ExampleGalleryActions = {
  SET_IS_OPEN: 'SET_IS_OPEN',
  SET_EXAMPLE: 'SET_EXAMPLE',
  SET_LINKED_EXAMPLE: 'SET_LINKED_EXAMPLE',
  ON_LOAD_LINKED_EXAMPLE: 'ON_LOAD_LINKED_EXAMPLE',
  ON_LOAD_POPUP: 'ON_LOAD_POPUP',
  SET_EXAMPLE_ID: 'SET_EXAMPLE_ID',
};

export const NavigationBarActions = {
  ON_LOAD_THEME: 'ON_LOAD_THEME',
  SAVE_THEME: 'SAVE_THEME',
  UPDATE_THEME: 'UPDATE_THEME',
};
export const PreviewPanelActions = {
  SET_RELOAD: 'SET_RELOAD',
};

export const EventPanelActions = {
  UPDATE_EVENT_CONTENT: 'UPDATE_EVENT_CONTENT',
};

export const OnboardingActions = {
  START_WELCOME_ONBOARDING: 'START_WELCOME_ONBOARDING',
  START_TOUR_ONBOARDING: 'START_TOUR_ONBOARDING',
  STOP_WELCOME_ONBOARDING: 'STOP_WELCOME_ONBOARDING',
  STOP_TOUR_ONBOARDING: 'STOP_TOUR_ONBOARDING',
  SWITCH_WELCOME_ONBOARDING_STEP: 'SWITCH_WELCOME_ONBOARDING_STEP',
  SWITCH_TOUR_ONBOARDING_STEP: 'SWITCH_TOUR_ONBOARDING_STEP',
  INCREASE_WELCOME_ONBOARDING_STEP: 'INCREASE_WELCOME_ONBOARDING_STEP',
  DECREASE_WELCOME_ONBOARDING_STEP: 'DECREASE_WELCOME_ONBOARDING_STEP',
  INCREASE_TOUR_ONBOARDING_STEP: 'INCREASE_TOUR_ONBOARDING_STEP',
  DECREASE_TOUR_ONBOARDING_STEP: 'DECREASE_TOUR_ONBOARDING_STEP',
  UPDATE_IMAGE_INFO: 'UPDATE_IMAGE_INFO',
  LOAD_ONBOARDING: 'LOAD_ONBOARDING',
  SET_IS_NEW_USER: 'SET_IS_NEW_USER',
};

export const EnvironmentSettingActions = {
  SET_IS_OPEN: 'SET_ENV_IS_OPEN',
  UPDATE_ENV: 'UPDATE_ENV',
  RESTORE_ENV: 'RESTORE_ENV',
  CHANGE_TYPE: 'CHANGE_TYPE_ON_ENV',
  UPDATE_URL: 'UPDATE_URL',
  UPDATE_USERNSME: 'UPDATE_USERNAME',
  UPDATE_PASSWORD: 'UPDATE_PASSWORD',
  UPDATE_CONTENT_GROUP: 'UPDATE_CONTENT_GROUP',
  CLEAR_ENV: 'CLEAR_ENV',
};

/* Local Storage Constants */
// Code Panel
export const savedCode = 'savedCode';
// Navigation bar theme
export const darkModeSetting = 'darkModeSetting';
// Dossier Popup
export const exampleIdString = 'exampleId';
// to distinguish with the old browser's embeddingType variable
export const embeddingTypeString = 'embeddingTypeV2';

/* UI Settings */
export const CARD_HEADER_HEIGHT = 40;
export const SCROLLBAR_HEIGHT = 25;
export const CARD_SHADOW_MARGIN_TOP = 15;
export const CARD_SHADOW_MARGIN_BOTTOM = 10;
